import { jsx as f, Fragment as Ae, jsxs as ve } from "react/jsx-runtime";
import * as s from "react";
import ne from "react";
import { o as Zn, p as Ie, q as ie, r as oe, s as Z, t as Jn, v as Qn, w as eo, x as to, y as no, z as oo, A as ro, C as ao, D as io, E as so, F as Fe, G as Pe, H as co, I as lo, J as uo, K as fo, R as po, L as mo, M as Pt } from "./sidebar-59b82a61.js";
import * as fn from "react-dom";
import { ChevronRight as ji, Check as ho, Circle as Xi, ChevronDown as go, ChevronUp as qi, GripVertical as Zi } from "lucide-react";
var vo = s.forwardRef((e, t) => {
  const { children: n, ...o } = e, r = s.Children.toArray(n), a = r.find(Qi);
  if (a) {
    const i = a.props.children, c = r.map((l) => l === a ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ f(qt, { ...o, ref: t, children: s.isValidElement(i) ? s.cloneElement(i, void 0, c) : null });
  }
  return /* @__PURE__ */ f(qt, { ...o, ref: t, children: n });
});
vo.displayName = "Slot";
var qt = s.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (s.isValidElement(n)) {
    const r = ts(n);
    return s.cloneElement(n, {
      ...es(o, n.props),
      // @ts-ignore
      ref: t ? Zn(t, r) : r
    });
  }
  return s.Children.count(n) > 1 ? s.Children.only(null) : null;
});
qt.displayName = "SlotClone";
var Ji = ({ children: e }) => /* @__PURE__ */ f(Ae, { children: e });
function Qi(e) {
  return s.isValidElement(e) && e.type === Ji;
}
function es(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...c) => {
      a(...c), r(...c);
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ts(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var ns = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], pn = ns.reduce((e, t) => {
  const n = s.forwardRef((o, r) => {
    const { asChild: a, ...i } = o, c = a ? vo : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(c, { ...i, ref: r });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), mn = "Avatar", [os, Gd] = Ie(mn), [rs, wo] = os(mn), So = s.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...o } = e, [r, a] = s.useState("idle");
    return /* @__PURE__ */ f(
      rs,
      {
        scope: n,
        imageLoadingStatus: r,
        onImageLoadingStatusChange: a,
        children: /* @__PURE__ */ f(pn.span, { ...o, ref: t })
      }
    );
  }
);
So.displayName = mn;
var yo = "AvatarImage", bo = s.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: o, onLoadingStatusChange: r = () => {
    }, ...a } = e, i = wo(yo, n), c = as(o, a.referrerPolicy), l = ie((u) => {
      r(u), i.onImageLoadingStatusChange(u);
    });
    return oe(() => {
      c !== "idle" && l(c);
    }, [c, l]), c === "loaded" ? /* @__PURE__ */ f(pn.img, { ...a, ref: t, src: o }) : null;
  }
);
bo.displayName = yo;
var Co = "AvatarFallback", xo = s.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: o, ...r } = e, a = wo(Co, n), [i, c] = s.useState(o === void 0);
    return s.useEffect(() => {
      if (o !== void 0) {
        const l = window.setTimeout(() => c(!0), o);
        return () => window.clearTimeout(l);
      }
    }, [o]), i && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ f(pn.span, { ...r, ref: t }) : null;
  }
);
xo.displayName = Co;
function as(e, t) {
  const [n, o] = s.useState("idle");
  return oe(() => {
    if (!e) {
      o("error");
      return;
    }
    let r = !0;
    const a = new window.Image(), i = (c) => () => {
      r && o(c);
    };
    return o("loading"), a.onload = i("loaded"), a.onerror = i("error"), a.src = e, t && (a.referrerPolicy = t), () => {
      r = !1;
    };
  }, [e, t]), n;
}
var Po = So, Ro = bo, No = xo;
const is = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Po,
  {
    ref: n,
    className: Z(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
      e
    ),
    ...t
  }
));
is.displayName = Po.displayName;
const ss = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Ro,
  {
    ref: n,
    className: Z("aspect-square h-full w-full", e),
    ...t
  }
));
ss.displayName = Ro.displayName;
const cs = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  No,
  {
    ref: n,
    className: Z(
      "flex h-full w-full items-center justify-center rounded-full bg-muted",
      e
    ),
    ...t
  }
));
cs.displayName = No.displayName;
function X(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function ls(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Dt(...e) {
  return (t) => e.forEach((n) => ls(n, t));
}
function Ce(...e) {
  return s.useCallback(Dt(...e), e);
}
var st = s.forwardRef((e, t) => {
  const { children: n, ...o } = e, r = s.Children.toArray(n), a = r.find(ds);
  if (a) {
    const i = a.props.children, c = r.map((l) => l === a ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ f(Zt, { ...o, ref: t, children: s.isValidElement(i) ? s.cloneElement(i, void 0, c) : null });
  }
  return /* @__PURE__ */ f(Zt, { ...o, ref: t, children: n });
});
st.displayName = "Slot";
var Zt = s.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (s.isValidElement(n)) {
    const r = ps(n);
    return s.cloneElement(n, {
      ...fs(o, n.props),
      // @ts-ignore
      ref: t ? Dt(t, r) : r
    });
  }
  return s.Children.count(n) > 1 ? s.Children.only(null) : null;
});
Zt.displayName = "SlotClone";
var us = ({ children: e }) => /* @__PURE__ */ f(Ae, { children: e });
function ds(e) {
  return s.isValidElement(e) && e.type === us;
}
function fs(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...c) => {
      a(...c), r(...c);
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ps(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var ms = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], xe = ms.reduce((e, t) => {
  const n = s.forwardRef((o, r) => {
    const { asChild: a, ...i } = o, c = a ? st : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(c, { ...i, ref: r });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function hs(e, t) {
  e && fn.flushSync(() => e.dispatchEvent(t));
}
function gs(e, t = []) {
  let n = [];
  function o(a, i) {
    const c = s.createContext(i), l = n.length;
    n = [...n, i];
    function u(d) {
      const { scope: p, children: g, ...h } = d, v = (p == null ? void 0 : p[e][l]) || c, S = s.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ f(v.Provider, { value: S, children: g });
    }
    function m(d, p) {
      const g = (p == null ? void 0 : p[e][l]) || c, h = s.useContext(g);
      if (h)
        return h;
      if (i !== void 0)
        return i;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return u.displayName = a + "Provider", [u, m];
  }
  const r = () => {
    const a = n.map((i) => s.createContext(i));
    return function(c) {
      const l = (c == null ? void 0 : c[e]) || a;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: l } }),
        [c, l]
      );
    };
  };
  return r.scopeName = e, [o, vs(r, ...t)];
}
function vs(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = o.reduce((c, { useScope: l, scopeName: u }) => {
        const d = l(a)[`__scope${u}`];
        return { ...c, ...d };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Eo(e) {
  const t = e + "CollectionProvider", [n, o] = gs(t), [r, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (g) => {
    const { scope: h, children: v } = g, S = ne.useRef(null), w = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ f(r, { scope: h, itemMap: w, collectionRef: S, children: v });
  };
  i.displayName = t;
  const c = e + "CollectionSlot", l = ne.forwardRef(
    (g, h) => {
      const { scope: v, children: S } = g, w = a(c, v), y = Ce(h, w.collectionRef);
      return /* @__PURE__ */ f(st, { ref: y, children: S });
    }
  );
  l.displayName = c;
  const u = e + "CollectionItemSlot", m = "data-radix-collection-item", d = ne.forwardRef(
    (g, h) => {
      const { scope: v, children: S, ...w } = g, y = ne.useRef(null), C = Ce(h, y), N = a(u, v);
      return ne.useEffect(() => (N.itemMap.set(y, { ref: y, ...w }), () => void N.itemMap.delete(y))), /* @__PURE__ */ f(st, { [m]: "", ref: C, children: S });
    }
  );
  d.displayName = u;
  function p(g) {
    const h = a(e + "CollectionConsumer", g);
    return ne.useCallback(() => {
      const S = h.collectionRef.current;
      if (!S)
        return [];
      const w = Array.from(S.querySelectorAll(`[${m}]`));
      return Array.from(h.itemMap.values()).sort(
        (N, z) => w.indexOf(N.ref.current) - w.indexOf(z.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: i, Slot: l, ItemSlot: d },
    p,
    o
  ];
}
var ws = s.createContext(void 0);
function Je(e) {
  const t = s.useContext(ws);
  return e || t || "ltr";
}
var Ss = "Arrow", Ao = s.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...a } = e;
  return /* @__PURE__ */ f(
    xe.svg,
    {
      ...a,
      ref: t,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ f("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Ao.displayName = Ss;
var ys = Ao;
function bs(e, t = []) {
  let n = [];
  function o(a, i) {
    const c = s.createContext(i), l = n.length;
    n = [...n, i];
    function u(d) {
      const { scope: p, children: g, ...h } = d, v = (p == null ? void 0 : p[e][l]) || c, S = s.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ f(v.Provider, { value: S, children: g });
    }
    function m(d, p) {
      const g = (p == null ? void 0 : p[e][l]) || c, h = s.useContext(g);
      if (h)
        return h;
      if (i !== void 0)
        return i;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return u.displayName = a + "Provider", [u, m];
  }
  const r = () => {
    const a = n.map((i) => s.createContext(i));
    return function(c) {
      const l = (c == null ? void 0 : c[e]) || a;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: l } }),
        [c, l]
      );
    };
  };
  return r.scopeName = e, [o, Cs(r, ...t)];
}
function Cs(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = o.reduce((c, { useScope: l, scopeName: u }) => {
        const d = l(a)[`__scope${u}`];
        return { ...c, ...d };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var hn = "Popper", [Mo, Io] = bs(hn), [xs, _o] = Mo(hn), To = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = s.useState(null);
  return /* @__PURE__ */ f(xs, { scope: t, anchor: o, onAnchorChange: r, children: n });
};
To.displayName = hn;
var Do = "PopperAnchor", Oo = s.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...r } = e, a = _o(Do, n), i = s.useRef(null), c = Ce(t, i);
    return s.useEffect(() => {
      a.onAnchorChange((o == null ? void 0 : o.current) || i.current);
    }), o ? null : /* @__PURE__ */ f(xe.div, { ...r, ref: c });
  }
);
Oo.displayName = Do;
var gn = "PopperContent", [Ps, Rs] = Mo(gn), $o = s.forwardRef(
  (e, t) => {
    var b, E, D, O, W, U;
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: c = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: m = 0,
      sticky: d = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: g = "optimized",
      onPlaced: h,
      ...v
    } = e, S = _o(gn, n), [w, y] = s.useState(null), C = Ce(t, (B) => y(B)), [N, z] = s.useState(null), M = Jn(N), P = (M == null ? void 0 : M.width) ?? 0, R = (M == null ? void 0 : M.height) ?? 0, T = o + (a !== "center" ? "-" + a : ""), V = typeof m == "number" ? m : { top: 0, right: 0, bottom: 0, left: 0, ...m }, k = Array.isArray(u) ? u : [u], F = k.length > 0, j = {
      padding: V,
      boundary: k.filter(Es),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: F
    }, { refs: Y, floatingStyles: G, placement: $, isPositioned: J, middlewareData: K } = Qn({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: T,
      whileElementsMounted: (...B) => eo(...B, {
        animationFrame: g === "always"
      }),
      elements: {
        reference: S.anchor
      },
      middleware: [
        to({ mainAxis: r + R, alignmentAxis: i }),
        l && no({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? oo() : void 0,
          ...j
        }),
        l && ro({ ...j }),
        ao({
          ...j,
          apply: ({ elements: B, rects: ee, availableWidth: fe, availableHeight: me }) => {
            const { width: Se, height: re } = ee.reference, he = B.floating.style;
            he.setProperty("--radix-popper-available-width", `${fe}px`), he.setProperty("--radix-popper-available-height", `${me}px`), he.setProperty("--radix-popper-anchor-width", `${Se}px`), he.setProperty("--radix-popper-anchor-height", `${re}px`);
          }
        }),
        N && io({ element: N, padding: c }),
        As({ arrowWidth: P, arrowHeight: R }),
        p && so({ strategy: "referenceHidden", ...j })
      ]
    }), [A, Q] = ko($), q = ie(h);
    oe(() => {
      J && (q == null || q());
    }, [J, q]);
    const te = (b = K.arrow) == null ? void 0 : b.x, x = (E = K.arrow) == null ? void 0 : E.y, I = ((D = K.arrow) == null ? void 0 : D.centerOffset) !== 0, [L, _] = s.useState();
    return oe(() => {
      w && _(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ f(
      "div",
      {
        ref: Y.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: J ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: L,
          "--radix-popper-transform-origin": [
            (O = K.transformOrigin) == null ? void 0 : O.x,
            (W = K.transformOrigin) == null ? void 0 : W.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((U = K.hide) == null ? void 0 : U.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ f(
          Ps,
          {
            scope: n,
            placedSide: A,
            onArrowChange: z,
            arrowX: te,
            arrowY: x,
            shouldHideArrow: I,
            children: /* @__PURE__ */ f(
              xe.div,
              {
                "data-side": A,
                "data-align": Q,
                ...v,
                ref: C,
                style: {
                  ...v.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: J ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
$o.displayName = gn;
var Lo = "PopperArrow", Ns = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, zo = s.forwardRef(function(t, n) {
  const { __scopePopper: o, ...r } = t, a = Rs(Lo, o), i = Ns[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ f(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ f(
          ys,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
zo.displayName = Lo;
function Es(e) {
  return e !== null;
}
var As = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var S, w, y;
    const { placement: n, rects: o, middlewareData: r } = t, i = ((S = r.arrow) == null ? void 0 : S.centerOffset) !== 0, c = i ? 0 : e.arrowWidth, l = i ? 0 : e.arrowHeight, [u, m] = ko(n), d = { start: "0%", center: "50%", end: "100%" }[m], p = (((w = r.arrow) == null ? void 0 : w.x) ?? 0) + c / 2, g = (((y = r.arrow) == null ? void 0 : y.y) ?? 0) + l / 2;
    let h = "", v = "";
    return u === "bottom" ? (h = i ? d : `${p}px`, v = `${-l}px`) : u === "top" ? (h = i ? d : `${p}px`, v = `${o.floating.height + l}px`) : u === "right" ? (h = `${-l}px`, v = i ? d : `${g}px`) : u === "left" && (h = `${o.floating.width + l}px`, v = i ? d : `${g}px`), { data: { x: h, y: v } };
  }
});
function ko(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Fo = To, Ms = Oo, Is = $o, _s = zo;
function Ts(e, t) {
  return s.useReducer((n, o) => t[n][o] ?? n, e);
}
var pt = (e) => {
  const { present: t, children: n } = e, o = Ds(t), r = typeof n == "function" ? n({ present: o.isPresent }) : s.Children.only(n), a = Ce(o.ref, Os(r));
  return typeof n == "function" || o.isPresent ? s.cloneElement(r, { ref: a }) : null;
};
pt.displayName = "Presence";
function Ds(e) {
  const [t, n] = s.useState(), o = s.useRef({}), r = s.useRef(e), a = s.useRef("none"), i = e ? "mounted" : "unmounted", [c, l] = Ts(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const u = yt(o.current);
    a.current = c === "mounted" ? u : "none";
  }, [c]), oe(() => {
    const u = o.current, m = r.current;
    if (m !== e) {
      const p = a.current, g = yt(u);
      e ? l("MOUNT") : g === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(m && p !== g ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, l]), oe(() => {
    if (t) {
      let u;
      const m = t.ownerDocument.defaultView ?? window, d = (g) => {
        const v = yt(o.current).includes(g.animationName);
        if (g.target === t && v && (l("ANIMATION_END"), !r.current)) {
          const S = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = S);
          });
        }
      }, p = (g) => {
        g.target === t && (a.current = yt(o.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        m.clearTimeout(u), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: s.useCallback((u) => {
      u && (o.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function yt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Os(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function $s(e, t = []) {
  let n = [];
  function o(a, i) {
    const c = s.createContext(i), l = n.length;
    n = [...n, i];
    function u(d) {
      const { scope: p, children: g, ...h } = d, v = (p == null ? void 0 : p[e][l]) || c, S = s.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ f(v.Provider, { value: S, children: g });
    }
    function m(d, p) {
      const g = (p == null ? void 0 : p[e][l]) || c, h = s.useContext(g);
      if (h)
        return h;
      if (i !== void 0)
        return i;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return u.displayName = a + "Provider", [u, m];
  }
  const r = () => {
    const a = n.map((i) => s.createContext(i));
    return function(c) {
      const l = (c == null ? void 0 : c[e]) || a;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: l } }),
        [c, l]
      );
    };
  };
  return r.scopeName = e, [o, Ls(r, ...t)];
}
function Ls(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = o.reduce((c, { useScope: l, scopeName: u }) => {
        const d = l(a)[`__scope${u}`];
        return { ...c, ...d };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Kt = "rovingFocusGroup.onEntryFocus", zs = { bubbles: !1, cancelable: !0 }, Ot = "RovingFocusGroup", [Jt, Vo, ks] = Eo(Ot), [Fs, Wo] = $s(
  Ot,
  [ks]
), [Vs, Ws] = Fs(Ot), Uo = s.forwardRef(
  (e, t) => /* @__PURE__ */ f(Jt.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f(Jt.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f(Us, { ...e, ref: t }) }) })
);
Uo.displayName = Ot;
var Us = s.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: r = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: c,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: m = !1,
    ...d
  } = e, p = s.useRef(null), g = Ce(t, p), h = Je(a), [v = null, S] = Fe({
    prop: i,
    defaultProp: c,
    onChange: l
  }), [w, y] = s.useState(!1), C = ie(u), N = Vo(n), z = s.useRef(!1), [M, P] = s.useState(0);
  return s.useEffect(() => {
    const R = p.current;
    if (R)
      return R.addEventListener(Kt, C), () => R.removeEventListener(Kt, C);
  }, [C]), /* @__PURE__ */ f(
    Vs,
    {
      scope: n,
      orientation: o,
      dir: h,
      loop: r,
      currentTabStopId: v,
      onItemFocus: s.useCallback(
        (R) => S(R),
        [S]
      ),
      onItemShiftTab: s.useCallback(() => y(!0), []),
      onFocusableItemAdd: s.useCallback(
        () => P((R) => R + 1),
        []
      ),
      onFocusableItemRemove: s.useCallback(
        () => P((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ f(
        xe.div,
        {
          tabIndex: w || M === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: g,
          style: { outline: "none", ...e.style },
          onMouseDown: X(e.onMouseDown, () => {
            z.current = !0;
          }),
          onFocus: X(e.onFocus, (R) => {
            const T = !z.current;
            if (R.target === R.currentTarget && T && !w) {
              const V = new CustomEvent(Kt, zs);
              if (R.currentTarget.dispatchEvent(V), !V.defaultPrevented) {
                const k = N().filter(($) => $.focusable), F = k.find(($) => $.active), j = k.find(($) => $.id === v), G = [F, j, ...k].filter(
                  Boolean
                ).map(($) => $.ref.current);
                Go(G, m);
              }
            }
            z.current = !1;
          }),
          onBlur: X(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), Bo = "RovingFocusGroupItem", Ho = s.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: r = !1,
      tabStopId: a,
      ...i
    } = e, c = Pe(), l = a || c, u = Ws(Bo, n), m = u.currentTabStopId === l, d = Vo(n), { onFocusableItemAdd: p, onFocusableItemRemove: g } = u;
    return s.useEffect(() => {
      if (o)
        return p(), () => g();
    }, [o, p, g]), /* @__PURE__ */ f(
      Jt.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: o,
        active: r,
        children: /* @__PURE__ */ f(
          xe.span,
          {
            tabIndex: m ? 0 : -1,
            "data-orientation": u.orientation,
            ...i,
            ref: t,
            onMouseDown: X(e.onMouseDown, (h) => {
              o ? u.onItemFocus(l) : h.preventDefault();
            }),
            onFocus: X(e.onFocus, () => u.onItemFocus(l)),
            onKeyDown: X(e.onKeyDown, (h) => {
              if (h.key === "Tab" && h.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (h.target !== h.currentTarget)
                return;
              const v = Gs(h, u.orientation, u.dir);
              if (v !== void 0) {
                if (h.metaKey || h.ctrlKey || h.altKey || h.shiftKey)
                  return;
                h.preventDefault();
                let w = d().filter((y) => y.focusable).map((y) => y.ref.current);
                if (v === "last")
                  w.reverse();
                else if (v === "prev" || v === "next") {
                  v === "prev" && w.reverse();
                  const y = w.indexOf(h.currentTarget);
                  w = u.loop ? Ks(w, y + 1) : w.slice(y + 1);
                }
                setTimeout(() => Go(w));
              }
            })
          }
        )
      }
    );
  }
);
Ho.displayName = Bo;
var Bs = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Hs(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Gs(e, t, n) {
  const o = Hs(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return Bs[o];
}
function Go(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n))
      return;
}
function Ks(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var Ys = Uo, js = Ho, Qt = ["Enter", " "], Xs = ["ArrowDown", "PageUp", "Home"], Ko = ["ArrowUp", "PageDown", "End"], qs = [...Xs, ...Ko], Zs = {
  ltr: [...Qt, "ArrowRight"],
  rtl: [...Qt, "ArrowLeft"]
}, Js = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, mt = "Menu", [ct, Qs, ec] = Eo(mt), [Ue, Yo] = Ie(mt, [
  ec,
  Io,
  Wo
]), ht = Io(), jo = Wo(), [Xo, _e] = Ue(mt), [tc, gt] = Ue(mt), qo = (e) => {
  const { __scopeMenu: t, open: n = !1, children: o, dir: r, onOpenChange: a, modal: i = !0 } = e, c = ht(t), [l, u] = s.useState(null), m = s.useRef(!1), d = ie(a), p = Je(r);
  return s.useEffect(() => {
    const g = () => {
      m.current = !0, document.addEventListener("pointerdown", h, { capture: !0, once: !0 }), document.addEventListener("pointermove", h, { capture: !0, once: !0 });
    }, h = () => m.current = !1;
    return document.addEventListener("keydown", g, { capture: !0 }), () => {
      document.removeEventListener("keydown", g, { capture: !0 }), document.removeEventListener("pointerdown", h, { capture: !0 }), document.removeEventListener("pointermove", h, { capture: !0 });
    };
  }, []), /* @__PURE__ */ f(Fo, { ...c, children: /* @__PURE__ */ f(
    Xo,
    {
      scope: t,
      open: n,
      onOpenChange: d,
      content: l,
      onContentChange: u,
      children: /* @__PURE__ */ f(
        tc,
        {
          scope: t,
          onClose: s.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: m,
          dir: p,
          modal: i,
          children: o
        }
      )
    }
  ) });
};
qo.displayName = mt;
var nc = "MenuAnchor", vn = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = ht(n);
    return /* @__PURE__ */ f(Ms, { ...r, ...o, ref: t });
  }
);
vn.displayName = nc;
var wn = "MenuPortal", [oc, Zo] = Ue(wn, {
  forceMount: void 0
}), Jo = (e) => {
  const { __scopeMenu: t, forceMount: n, children: o, container: r } = e, a = _e(wn, t);
  return /* @__PURE__ */ f(oc, { scope: t, forceMount: n, children: /* @__PURE__ */ f(pt, { present: n || a.open, children: /* @__PURE__ */ f(mo, { asChild: !0, container: r, children: o }) }) });
};
Jo.displayName = wn;
var ge = "MenuContent", [rc, Sn] = Ue(ge), Qo = s.forwardRef(
  (e, t) => {
    const n = Zo(ge, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, a = _e(ge, e.__scopeMenu), i = gt(ge, e.__scopeMenu);
    return /* @__PURE__ */ f(ct.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(pt, { present: o || a.open, children: /* @__PURE__ */ f(ct.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ f(ac, { ...r, ref: t }) : /* @__PURE__ */ f(ic, { ...r, ref: t }) }) }) });
  }
), ac = s.forwardRef(
  (e, t) => {
    const n = _e(ge, e.__scopeMenu), o = s.useRef(null), r = Ce(t, o);
    return s.useEffect(() => {
      const a = o.current;
      if (a)
        return co(a);
    }, []), /* @__PURE__ */ f(
      yn,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: X(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), ic = s.forwardRef((e, t) => {
  const n = _e(ge, e.__scopeMenu);
  return /* @__PURE__ */ f(
    yn,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), yn = s.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: o = !1,
      trapFocus: r,
      onOpenAutoFocus: a,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: c,
      onEntryFocus: l,
      onEscapeKeyDown: u,
      onPointerDownOutside: m,
      onFocusOutside: d,
      onInteractOutside: p,
      onDismiss: g,
      disableOutsideScroll: h,
      ...v
    } = e, S = _e(ge, n), w = gt(ge, n), y = ht(n), C = jo(n), N = Qs(n), [z, M] = s.useState(null), P = s.useRef(null), R = Ce(t, P, S.onContentChange), T = s.useRef(0), V = s.useRef(""), k = s.useRef(0), F = s.useRef(null), j = s.useRef("right"), Y = s.useRef(0), G = h ? po : s.Fragment, $ = h ? { as: st, allowPinchZoom: !0 } : void 0, J = (A) => {
      var b, E;
      const Q = V.current + A, q = N().filter((D) => !D.disabled), te = document.activeElement, x = (b = q.find((D) => D.ref.current === te)) == null ? void 0 : b.textValue, I = q.map((D) => D.textValue), L = wc(I, Q, x), _ = (E = q.find((D) => D.textValue === L)) == null ? void 0 : E.ref.current;
      (function D(O) {
        V.current = O, window.clearTimeout(T.current), O !== "" && (T.current = window.setTimeout(() => D(""), 1e3));
      })(Q), _ && setTimeout(() => _.focus());
    };
    s.useEffect(() => () => window.clearTimeout(T.current), []), lo();
    const K = s.useCallback((A) => {
      var q, te;
      return j.current === ((q = F.current) == null ? void 0 : q.side) && yc(A, (te = F.current) == null ? void 0 : te.area);
    }, []);
    return /* @__PURE__ */ f(
      rc,
      {
        scope: n,
        searchRef: V,
        onItemEnter: s.useCallback(
          (A) => {
            K(A) && A.preventDefault();
          },
          [K]
        ),
        onItemLeave: s.useCallback(
          (A) => {
            var Q;
            K(A) || ((Q = P.current) == null || Q.focus(), M(null));
          },
          [K]
        ),
        onTriggerLeave: s.useCallback(
          (A) => {
            K(A) && A.preventDefault();
          },
          [K]
        ),
        pointerGraceTimerRef: k,
        onPointerGraceIntentChange: s.useCallback((A) => {
          F.current = A;
        }, []),
        children: /* @__PURE__ */ f(G, { ...$, children: /* @__PURE__ */ f(
          uo,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: X(a, (A) => {
              var Q;
              A.preventDefault(), (Q = P.current) == null || Q.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ f(
              fo,
              {
                asChild: !0,
                disableOutsidePointerEvents: c,
                onEscapeKeyDown: u,
                onPointerDownOutside: m,
                onFocusOutside: d,
                onInteractOutside: p,
                onDismiss: g,
                children: /* @__PURE__ */ f(
                  Ys,
                  {
                    asChild: !0,
                    ...C,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: o,
                    currentTabStopId: z,
                    onCurrentTabStopIdChange: M,
                    onEntryFocus: X(l, (A) => {
                      w.isUsingKeyboardRef.current || A.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ f(
                      Is,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": gr(S.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ...y,
                        ...v,
                        ref: R,
                        style: { outline: "none", ...v.style },
                        onKeyDown: X(v.onKeyDown, (A) => {
                          const q = A.target.closest("[data-radix-menu-content]") === A.currentTarget, te = A.ctrlKey || A.altKey || A.metaKey, x = A.key.length === 1;
                          q && (A.key === "Tab" && A.preventDefault(), !te && x && J(A.key));
                          const I = P.current;
                          if (A.target !== I || !qs.includes(A.key))
                            return;
                          A.preventDefault();
                          const _ = N().filter((b) => !b.disabled).map((b) => b.ref.current);
                          Ko.includes(A.key) && _.reverse(), gc(_);
                        }),
                        onBlur: X(e.onBlur, (A) => {
                          A.currentTarget.contains(A.target) || (window.clearTimeout(T.current), V.current = "");
                        }),
                        onPointerMove: X(
                          e.onPointerMove,
                          lt((A) => {
                            const Q = A.target, q = Y.current !== A.clientX;
                            if (A.currentTarget.contains(Q) && q) {
                              const te = A.clientX > Y.current ? "right" : "left";
                              j.current = te, Y.current = A.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Qo.displayName = ge;
var sc = "MenuGroup", bn = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ f(xe.div, { role: "group", ...o, ref: t });
  }
);
bn.displayName = sc;
var cc = "MenuLabel", er = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ f(xe.div, { ...o, ref: t });
  }
);
er.displayName = cc;
var Rt = "MenuItem", Vn = "menu.itemSelect", $t = s.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: o, ...r } = e, a = s.useRef(null), i = gt(Rt, e.__scopeMenu), c = Sn(Rt, e.__scopeMenu), l = Ce(t, a), u = s.useRef(!1), m = () => {
      const d = a.current;
      if (!n && d) {
        const p = new CustomEvent(Vn, { bubbles: !0, cancelable: !0 });
        d.addEventListener(Vn, (g) => o == null ? void 0 : o(g), { once: !0 }), hs(d, p), p.defaultPrevented ? u.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ f(
      tr,
      {
        ...r,
        ref: l,
        disabled: n,
        onClick: X(e.onClick, m),
        onPointerDown: (d) => {
          var p;
          (p = e.onPointerDown) == null || p.call(e, d), u.current = !0;
        },
        onPointerUp: X(e.onPointerUp, (d) => {
          var p;
          u.current || (p = d.currentTarget) == null || p.click();
        }),
        onKeyDown: X(e.onKeyDown, (d) => {
          const p = c.searchRef.current !== "";
          n || p && d.key === " " || Qt.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
$t.displayName = Rt;
var tr = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: o = !1, textValue: r, ...a } = e, i = Sn(Rt, n), c = jo(n), l = s.useRef(null), u = Ce(t, l), [m, d] = s.useState(!1), [p, g] = s.useState("");
    return s.useEffect(() => {
      const h = l.current;
      h && g((h.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ f(
      ct.ItemSlot,
      {
        scope: n,
        disabled: o,
        textValue: r ?? p,
        children: /* @__PURE__ */ f(js, { asChild: !0, ...c, focusable: !o, children: /* @__PURE__ */ f(
          xe.div,
          {
            role: "menuitem",
            "data-highlighted": m ? "" : void 0,
            "aria-disabled": o || void 0,
            "data-disabled": o ? "" : void 0,
            ...a,
            ref: u,
            onPointerMove: X(
              e.onPointerMove,
              lt((h) => {
                o ? i.onItemLeave(h) : (i.onItemEnter(h), h.defaultPrevented || h.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: X(
              e.onPointerLeave,
              lt((h) => i.onItemLeave(h))
            ),
            onFocus: X(e.onFocus, () => d(!0)),
            onBlur: X(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), lc = "MenuCheckboxItem", nr = s.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: o, ...r } = e;
    return /* @__PURE__ */ f(sr, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ f(
      $t,
      {
        role: "menuitemcheckbox",
        "aria-checked": Nt(n) ? "mixed" : n,
        ...r,
        ref: t,
        "data-state": Pn(n),
        onSelect: X(
          r.onSelect,
          () => o == null ? void 0 : o(Nt(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
nr.displayName = lc;
var or = "MenuRadioGroup", [uc, dc] = Ue(
  or,
  { value: void 0, onValueChange: () => {
  } }
), rr = s.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: o, ...r } = e, a = ie(o);
    return /* @__PURE__ */ f(uc, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ f(bn, { ...r, ref: t }) });
  }
);
rr.displayName = or;
var ar = "MenuRadioItem", ir = s.forwardRef(
  (e, t) => {
    const { value: n, ...o } = e, r = dc(ar, e.__scopeMenu), a = n === r.value;
    return /* @__PURE__ */ f(sr, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ f(
      $t,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...o,
        ref: t,
        "data-state": Pn(a),
        onSelect: X(
          o.onSelect,
          () => {
            var i;
            return (i = r.onValueChange) == null ? void 0 : i.call(r, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
ir.displayName = ar;
var Cn = "MenuItemIndicator", [sr, fc] = Ue(
  Cn,
  { checked: !1 }
), cr = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: o, ...r } = e, a = fc(Cn, n);
    return /* @__PURE__ */ f(
      pt,
      {
        present: o || Nt(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ f(
          xe.span,
          {
            ...r,
            ref: t,
            "data-state": Pn(a.checked)
          }
        )
      }
    );
  }
);
cr.displayName = Cn;
var pc = "MenuSeparator", lr = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ f(
      xe.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...o,
        ref: t
      }
    );
  }
);
lr.displayName = pc;
var mc = "MenuArrow", ur = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = ht(n);
    return /* @__PURE__ */ f(_s, { ...r, ...o, ref: t });
  }
);
ur.displayName = mc;
var xn = "MenuSub", [hc, dr] = Ue(xn), fr = (e) => {
  const { __scopeMenu: t, children: n, open: o = !1, onOpenChange: r } = e, a = _e(xn, t), i = ht(t), [c, l] = s.useState(null), [u, m] = s.useState(null), d = ie(r);
  return s.useEffect(() => (a.open === !1 && d(!1), () => d(!1)), [a.open, d]), /* @__PURE__ */ f(Fo, { ...i, children: /* @__PURE__ */ f(
    Xo,
    {
      scope: t,
      open: o,
      onOpenChange: d,
      content: u,
      onContentChange: m,
      children: /* @__PURE__ */ f(
        hc,
        {
          scope: t,
          contentId: Pe(),
          triggerId: Pe(),
          trigger: c,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
fr.displayName = xn;
var ot = "MenuSubTrigger", pr = s.forwardRef(
  (e, t) => {
    const n = _e(ot, e.__scopeMenu), o = gt(ot, e.__scopeMenu), r = dr(ot, e.__scopeMenu), a = Sn(ot, e.__scopeMenu), i = s.useRef(null), { pointerGraceTimerRef: c, onPointerGraceIntentChange: l } = a, u = { __scopeMenu: e.__scopeMenu }, m = s.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return s.useEffect(() => m, [m]), s.useEffect(() => {
      const d = c.current;
      return () => {
        window.clearTimeout(d), l(null);
      };
    }, [c, l]), /* @__PURE__ */ f(vn, { asChild: !0, ...u, children: /* @__PURE__ */ f(
      tr,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": gr(n.open),
        ...e,
        ref: Dt(t, r.onTriggerChange),
        onClick: (d) => {
          var p;
          (p = e.onClick) == null || p.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: X(
          e.onPointerMove,
          lt((d) => {
            a.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              n.onOpenChange(!0), m();
            }, 100));
          })
        ),
        onPointerLeave: X(
          e.onPointerLeave,
          lt((d) => {
            var g, h;
            m();
            const p = (g = n.content) == null ? void 0 : g.getBoundingClientRect();
            if (p) {
              const v = (h = n.content) == null ? void 0 : h.dataset.side, S = v === "right", w = S ? -5 : 5, y = p[S ? "left" : "right"], C = p[S ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + w, y: d.clientY },
                  { x: y, y: p.top },
                  { x: C, y: p.top },
                  { x: C, y: p.bottom },
                  { x: y, y: p.bottom }
                ],
                side: v
              }), window.clearTimeout(c.current), c.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(d), d.defaultPrevented)
                return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: X(e.onKeyDown, (d) => {
          var g;
          const p = a.searchRef.current !== "";
          e.disabled || p && d.key === " " || Zs[o.dir].includes(d.key) && (n.onOpenChange(!0), (g = n.content) == null || g.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
pr.displayName = ot;
var mr = "MenuSubContent", hr = s.forwardRef(
  (e, t) => {
    const n = Zo(ge, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, a = _e(ge, e.__scopeMenu), i = gt(ge, e.__scopeMenu), c = dr(mr, e.__scopeMenu), l = s.useRef(null), u = Ce(t, l);
    return /* @__PURE__ */ f(ct.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(pt, { present: o || a.open, children: /* @__PURE__ */ f(ct.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(
      yn,
      {
        id: c.contentId,
        "aria-labelledby": c.triggerId,
        ...r,
        ref: u,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (m) => {
          var d;
          i.isUsingKeyboardRef.current && ((d = l.current) == null || d.focus()), m.preventDefault();
        },
        onCloseAutoFocus: (m) => m.preventDefault(),
        onFocusOutside: X(e.onFocusOutside, (m) => {
          m.target !== c.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: X(e.onEscapeKeyDown, (m) => {
          i.onClose(), m.preventDefault();
        }),
        onKeyDown: X(e.onKeyDown, (m) => {
          var g;
          const d = m.currentTarget.contains(m.target), p = Js[i.dir].includes(m.key);
          d && p && (a.onOpenChange(!1), (g = c.trigger) == null || g.focus(), m.preventDefault());
        })
      }
    ) }) }) });
  }
);
hr.displayName = mr;
function gr(e) {
  return e ? "open" : "closed";
}
function Nt(e) {
  return e === "indeterminate";
}
function Pn(e) {
  return Nt(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function gc(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function vc(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
function wc(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = vc(e, Math.max(a, 0));
  r.length === 1 && (i = i.filter((u) => u !== n));
  const l = i.find(
    (u) => u.toLowerCase().startsWith(r.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function Sc(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const c = t[a].x, l = t[a].y, u = t[i].x, m = t[i].y;
    l > o != m > o && n < (u - c) * (o - l) / (m - l) + c && (r = !r);
  }
  return r;
}
function yc(e, t) {
  if (!t)
    return !1;
  const n = { x: e.clientX, y: e.clientY };
  return Sc(n, t);
}
function lt(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var bc = qo, Cc = vn, xc = Jo, Pc = Qo, Rc = bn, Nc = er, Ec = $t, Ac = nr, Mc = rr, Ic = ir, _c = cr, Tc = lr, Dc = ur, Oc = fr, $c = pr, Lc = hr, Rn = "DropdownMenu", [zc, Kd] = Ie(
  Rn,
  [Yo]
), se = Yo(), [kc, vr] = zc(Rn), wr = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: o,
    open: r,
    defaultOpen: a,
    onOpenChange: i,
    modal: c = !0
  } = e, l = se(t), u = s.useRef(null), [m = !1, d] = Fe({
    prop: r,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ f(
    kc,
    {
      scope: t,
      triggerId: Pe(),
      triggerRef: u,
      contentId: Pe(),
      open: m,
      onOpenChange: d,
      onOpenToggle: s.useCallback(() => d((p) => !p), [d]),
      modal: c,
      children: /* @__PURE__ */ f(bc, { ...l, open: m, onOpenChange: d, dir: o, modal: c, children: n })
    }
  );
};
wr.displayName = Rn;
var Sr = "DropdownMenuTrigger", yr = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: o = !1, ...r } = e, a = vr(Sr, n), i = se(n);
    return /* @__PURE__ */ f(Cc, { asChild: !0, ...i, children: /* @__PURE__ */ f(
      xe.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": o ? "" : void 0,
        disabled: o,
        ...r,
        ref: Dt(t, a.triggerRef),
        onPointerDown: X(e.onPointerDown, (c) => {
          !o && c.button === 0 && c.ctrlKey === !1 && (a.onOpenToggle(), a.open || c.preventDefault());
        }),
        onKeyDown: X(e.onKeyDown, (c) => {
          o || (["Enter", " "].includes(c.key) && a.onOpenToggle(), c.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(c.key) && c.preventDefault());
        })
      }
    ) });
  }
);
yr.displayName = Sr;
var Fc = "DropdownMenuPortal", br = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, o = se(t);
  return /* @__PURE__ */ f(xc, { ...o, ...n });
};
br.displayName = Fc;
var Cr = "DropdownMenuContent", xr = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = vr(Cr, n), a = se(n), i = s.useRef(!1);
    return /* @__PURE__ */ f(
      Pc,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...a,
        ...o,
        ref: t,
        onCloseAutoFocus: X(e.onCloseAutoFocus, (c) => {
          var l;
          i.current || (l = r.triggerRef.current) == null || l.focus(), i.current = !1, c.preventDefault();
        }),
        onInteractOutside: X(e.onInteractOutside, (c) => {
          const l = c.detail.originalEvent, u = l.button === 0 && l.ctrlKey === !0, m = l.button === 2 || u;
          (!r.modal || m) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
xr.displayName = Cr;
var Vc = "DropdownMenuGroup", Pr = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = se(n);
    return /* @__PURE__ */ f(Rc, { ...r, ...o, ref: t });
  }
);
Pr.displayName = Vc;
var Wc = "DropdownMenuLabel", Rr = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = se(n);
    return /* @__PURE__ */ f(Nc, { ...r, ...o, ref: t });
  }
);
Rr.displayName = Wc;
var Uc = "DropdownMenuItem", Nr = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = se(n);
    return /* @__PURE__ */ f(Ec, { ...r, ...o, ref: t });
  }
);
Nr.displayName = Uc;
var Bc = "DropdownMenuCheckboxItem", Er = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = se(n);
  return /* @__PURE__ */ f(Ac, { ...r, ...o, ref: t });
});
Er.displayName = Bc;
var Hc = "DropdownMenuRadioGroup", Ar = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = se(n);
  return /* @__PURE__ */ f(Mc, { ...r, ...o, ref: t });
});
Ar.displayName = Hc;
var Gc = "DropdownMenuRadioItem", Mr = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = se(n);
  return /* @__PURE__ */ f(Ic, { ...r, ...o, ref: t });
});
Mr.displayName = Gc;
var Kc = "DropdownMenuItemIndicator", Ir = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = se(n);
  return /* @__PURE__ */ f(_c, { ...r, ...o, ref: t });
});
Ir.displayName = Kc;
var Yc = "DropdownMenuSeparator", _r = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = se(n);
  return /* @__PURE__ */ f(Tc, { ...r, ...o, ref: t });
});
_r.displayName = Yc;
var jc = "DropdownMenuArrow", Xc = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = se(n);
    return /* @__PURE__ */ f(Dc, { ...r, ...o, ref: t });
  }
);
Xc.displayName = jc;
var qc = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: o, onOpenChange: r, defaultOpen: a } = e, i = se(t), [c = !1, l] = Fe({
    prop: o,
    defaultProp: a,
    onChange: r
  });
  return /* @__PURE__ */ f(Oc, { ...i, open: c, onOpenChange: l, children: n });
}, Zc = "DropdownMenuSubTrigger", Tr = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = se(n);
  return /* @__PURE__ */ f($c, { ...r, ...o, ref: t });
});
Tr.displayName = Zc;
var Jc = "DropdownMenuSubContent", Dr = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = se(n);
  return /* @__PURE__ */ f(
    Lc,
    {
      ...r,
      ...o,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Dr.displayName = Jc;
var Qc = wr, el = yr, Or = br, $r = xr, tl = Pr, Lr = Rr, zr = Nr, kr = Er, nl = Ar, Fr = Mr, Vr = Ir, Wr = _r, ol = qc, Ur = Tr, Br = Dr;
const Yd = Qc, jd = el, Xd = tl, qd = Or, Zd = ol, Jd = nl, rl = s.forwardRef(({ className: e, inset: t, children: n, ...o }, r) => /* @__PURE__ */ ve(
  Ur,
  {
    ref: r,
    className: Z(
      "flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...o,
    children: [
      n,
      /* @__PURE__ */ f(ji, { className: "ml-auto" })
    ]
  }
));
rl.displayName = Ur.displayName;
const al = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Br,
  {
    ref: n,
    className: Z(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
al.displayName = Br.displayName;
const il = s.forwardRef(({ className: e, sideOffset: t = 4, ...n }, o) => /* @__PURE__ */ f(Or, { children: /* @__PURE__ */ f(
  $r,
  {
    ref: o,
    sideOffset: t,
    className: Z(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
il.displayName = $r.displayName;
const sl = s.forwardRef(({ className: e, inset: t, ...n }, o) => /* @__PURE__ */ f(
  zr,
  {
    ref: o,
    className: Z(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...n
  }
));
sl.displayName = zr.displayName;
const cl = s.forwardRef(({ className: e, children: t, checked: n, ...o }, r) => /* @__PURE__ */ ve(
  kr,
  {
    ref: r,
    className: Z(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...o,
    children: [
      /* @__PURE__ */ f("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ f(Vr, { children: /* @__PURE__ */ f(ho, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
cl.displayName = kr.displayName;
const ll = s.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ ve(
  Fr,
  {
    ref: o,
    className: Z(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ f("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ f(Vr, { children: /* @__PURE__ */ f(Xi, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
ll.displayName = Fr.displayName;
const ul = s.forwardRef(({ className: e, inset: t, ...n }, o) => /* @__PURE__ */ f(
  Lr,
  {
    ref: o,
    className: Z(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
ul.displayName = Lr.displayName;
const dl = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Wr,
  {
    ref: n,
    className: Z("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
dl.displayName = Wr.displayName;
const fl = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "span",
  {
    className: Z("ml-auto text-xs tracking-widest opacity-60", e),
    ...t
  }
);
fl.displayName = "DropdownMenuShortcut";
function en(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function ae(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function pl(e, t = []) {
  let n = [];
  function o(a, i) {
    const c = s.createContext(i), l = n.length;
    n = [...n, i];
    function u(d) {
      const { scope: p, children: g, ...h } = d, v = (p == null ? void 0 : p[e][l]) || c, S = s.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ f(v.Provider, { value: S, children: g });
    }
    function m(d, p) {
      const g = (p == null ? void 0 : p[e][l]) || c, h = s.useContext(g);
      if (h)
        return h;
      if (i !== void 0)
        return i;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return u.displayName = a + "Provider", [u, m];
  }
  const r = () => {
    const a = n.map((i) => s.createContext(i));
    return function(c) {
      const l = (c == null ? void 0 : c[e]) || a;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: l } }),
        [c, l]
      );
    };
  };
  return r.scopeName = e, [o, ml(r, ...t)];
}
function ml(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = o.reduce((c, { useScope: l, scopeName: u }) => {
        const d = l(a)[`__scope${u}`];
        return { ...c, ...d };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function hl(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Hr(...e) {
  return (t) => e.forEach((n) => hl(n, t));
}
function de(...e) {
  return s.useCallback(Hr(...e), e);
}
var ut = s.forwardRef((e, t) => {
  const { children: n, ...o } = e, r = s.Children.toArray(n), a = r.find(vl);
  if (a) {
    const i = a.props.children, c = r.map((l) => l === a ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ f(tn, { ...o, ref: t, children: s.isValidElement(i) ? s.cloneElement(i, void 0, c) : null });
  }
  return /* @__PURE__ */ f(tn, { ...o, ref: t, children: n });
});
ut.displayName = "Slot";
var tn = s.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (s.isValidElement(n)) {
    const r = Sl(n);
    return s.cloneElement(n, {
      ...wl(o, n.props),
      // @ts-ignore
      ref: t ? Hr(t, r) : r
    });
  }
  return s.Children.count(n) > 1 ? s.Children.only(null) : null;
});
tn.displayName = "SlotClone";
var gl = ({ children: e }) => /* @__PURE__ */ f(Ae, { children: e });
function vl(e) {
  return s.isValidElement(e) && e.type === gl;
}
function wl(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...c) => {
      a(...c), r(...c);
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Sl(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function yl(e) {
  const t = e + "CollectionProvider", [n, o] = pl(t), [r, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (g) => {
    const { scope: h, children: v } = g, S = ne.useRef(null), w = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ f(r, { scope: h, itemMap: w, collectionRef: S, children: v });
  };
  i.displayName = t;
  const c = e + "CollectionSlot", l = ne.forwardRef(
    (g, h) => {
      const { scope: v, children: S } = g, w = a(c, v), y = de(h, w.collectionRef);
      return /* @__PURE__ */ f(ut, { ref: y, children: S });
    }
  );
  l.displayName = c;
  const u = e + "CollectionItemSlot", m = "data-radix-collection-item", d = ne.forwardRef(
    (g, h) => {
      const { scope: v, children: S, ...w } = g, y = ne.useRef(null), C = de(h, y), N = a(u, v);
      return ne.useEffect(() => (N.itemMap.set(y, { ref: y, ...w }), () => void N.itemMap.delete(y))), /* @__PURE__ */ f(ut, { [m]: "", ref: C, children: S });
    }
  );
  d.displayName = u;
  function p(g) {
    const h = a(e + "CollectionConsumer", g);
    return ne.useCallback(() => {
      const S = h.collectionRef.current;
      if (!S)
        return [];
      const w = Array.from(S.querySelectorAll(`[${m}]`));
      return Array.from(h.itemMap.values()).sort(
        (N, z) => w.indexOf(N.ref.current) - w.indexOf(z.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: i, Slot: l, ItemSlot: d },
    p,
    o
  ];
}
var bl = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ce = bl.reduce((e, t) => {
  const n = s.forwardRef((o, r) => {
    const { asChild: a, ...i } = o, c = a ? ut : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(c, { ...i, ref: r });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Cl = "Arrow", Gr = s.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...a } = e;
  return /* @__PURE__ */ f(
    ce.svg,
    {
      ...a,
      ref: t,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ f("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Gr.displayName = Cl;
var xl = Gr;
function Pl(e, t = []) {
  let n = [];
  function o(a, i) {
    const c = s.createContext(i), l = n.length;
    n = [...n, i];
    function u(d) {
      const { scope: p, children: g, ...h } = d, v = (p == null ? void 0 : p[e][l]) || c, S = s.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ f(v.Provider, { value: S, children: g });
    }
    function m(d, p) {
      const g = (p == null ? void 0 : p[e][l]) || c, h = s.useContext(g);
      if (h)
        return h;
      if (i !== void 0)
        return i;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return u.displayName = a + "Provider", [u, m];
  }
  const r = () => {
    const a = n.map((i) => s.createContext(i));
    return function(c) {
      const l = (c == null ? void 0 : c[e]) || a;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: l } }),
        [c, l]
      );
    };
  };
  return r.scopeName = e, [o, Rl(r, ...t)];
}
function Rl(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = o.reduce((c, { useScope: l, scopeName: u }) => {
        const d = l(a)[`__scope${u}`];
        return { ...c, ...d };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Nn = "Popper", [Kr, Yr] = Pl(Nn), [Nl, jr] = Kr(Nn), Xr = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = s.useState(null);
  return /* @__PURE__ */ f(Nl, { scope: t, anchor: o, onAnchorChange: r, children: n });
};
Xr.displayName = Nn;
var qr = "PopperAnchor", Zr = s.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...r } = e, a = jr(qr, n), i = s.useRef(null), c = de(t, i);
    return s.useEffect(() => {
      a.onAnchorChange((o == null ? void 0 : o.current) || i.current);
    }), o ? null : /* @__PURE__ */ f(ce.div, { ...r, ref: c });
  }
);
Zr.displayName = qr;
var En = "PopperContent", [El, Al] = Kr(En), Jr = s.forwardRef(
  (e, t) => {
    var b, E, D, O, W, U;
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: c = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: m = 0,
      sticky: d = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: g = "optimized",
      onPlaced: h,
      ...v
    } = e, S = jr(En, n), [w, y] = s.useState(null), C = de(t, (B) => y(B)), [N, z] = s.useState(null), M = Jn(N), P = (M == null ? void 0 : M.width) ?? 0, R = (M == null ? void 0 : M.height) ?? 0, T = o + (a !== "center" ? "-" + a : ""), V = typeof m == "number" ? m : { top: 0, right: 0, bottom: 0, left: 0, ...m }, k = Array.isArray(u) ? u : [u], F = k.length > 0, j = {
      padding: V,
      boundary: k.filter(Il),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: F
    }, { refs: Y, floatingStyles: G, placement: $, isPositioned: J, middlewareData: K } = Qn({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: T,
      whileElementsMounted: (...B) => eo(...B, {
        animationFrame: g === "always"
      }),
      elements: {
        reference: S.anchor
      },
      middleware: [
        to({ mainAxis: r + R, alignmentAxis: i }),
        l && no({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? oo() : void 0,
          ...j
        }),
        l && ro({ ...j }),
        ao({
          ...j,
          apply: ({ elements: B, rects: ee, availableWidth: fe, availableHeight: me }) => {
            const { width: Se, height: re } = ee.reference, he = B.floating.style;
            he.setProperty("--radix-popper-available-width", `${fe}px`), he.setProperty("--radix-popper-available-height", `${me}px`), he.setProperty("--radix-popper-anchor-width", `${Se}px`), he.setProperty("--radix-popper-anchor-height", `${re}px`);
          }
        }),
        N && io({ element: N, padding: c }),
        _l({ arrowWidth: P, arrowHeight: R }),
        p && so({ strategy: "referenceHidden", ...j })
      ]
    }), [A, Q] = ta($), q = ie(h);
    oe(() => {
      J && (q == null || q());
    }, [J, q]);
    const te = (b = K.arrow) == null ? void 0 : b.x, x = (E = K.arrow) == null ? void 0 : E.y, I = ((D = K.arrow) == null ? void 0 : D.centerOffset) !== 0, [L, _] = s.useState();
    return oe(() => {
      w && _(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ f(
      "div",
      {
        ref: Y.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: J ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: L,
          "--radix-popper-transform-origin": [
            (O = K.transformOrigin) == null ? void 0 : O.x,
            (W = K.transformOrigin) == null ? void 0 : W.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((U = K.hide) == null ? void 0 : U.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ f(
          El,
          {
            scope: n,
            placedSide: A,
            onArrowChange: z,
            arrowX: te,
            arrowY: x,
            shouldHideArrow: I,
            children: /* @__PURE__ */ f(
              ce.div,
              {
                "data-side": A,
                "data-align": Q,
                ...v,
                ref: C,
                style: {
                  ...v.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: J ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Jr.displayName = En;
var Qr = "PopperArrow", Ml = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, ea = s.forwardRef(function(t, n) {
  const { __scopePopper: o, ...r } = t, a = Al(Qr, o), i = Ml[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ f(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ f(
          xl,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
ea.displayName = Qr;
function Il(e) {
  return e !== null;
}
var _l = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var S, w, y;
    const { placement: n, rects: o, middlewareData: r } = t, i = ((S = r.arrow) == null ? void 0 : S.centerOffset) !== 0, c = i ? 0 : e.arrowWidth, l = i ? 0 : e.arrowHeight, [u, m] = ta(n), d = { start: "0%", center: "50%", end: "100%" }[m], p = (((w = r.arrow) == null ? void 0 : w.x) ?? 0) + c / 2, g = (((y = r.arrow) == null ? void 0 : y.y) ?? 0) + l / 2;
    let h = "", v = "";
    return u === "bottom" ? (h = i ? d : `${p}px`, v = `${-l}px`) : u === "top" ? (h = i ? d : `${p}px`, v = `${o.floating.height + l}px`) : u === "right" ? (h = `${-l}px`, v = i ? d : `${g}px`) : u === "left" && (h = `${o.floating.width + l}px`, v = i ? d : `${g}px`), { data: { x: h, y: v } };
  }
});
function ta(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Tl = Xr, Dl = Zr, Ol = Jr, $l = ea;
function Ll(e) {
  const t = s.useRef({ value: e, previous: e });
  return s.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var zl = "VisuallyHidden", na = s.forwardRef(
  (e, t) => /* @__PURE__ */ f(
    ce.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
na.displayName = zl;
var kl = [" ", "Enter", "ArrowUp", "ArrowDown"], Fl = [" ", "Enter"], vt = "Select", [Lt, zt, Vl] = yl(vt), [Qe, Qd] = Ie(vt, [
  Vl,
  Yr
]), kt = Yr(), [Wl, Te] = Qe(vt), [Ul, Bl] = Qe(vt), oa = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    value: i,
    defaultValue: c,
    onValueChange: l,
    dir: u,
    name: m,
    autoComplete: d,
    disabled: p,
    required: g,
    form: h
  } = e, v = kt(t), [S, w] = s.useState(null), [y, C] = s.useState(null), [N, z] = s.useState(!1), M = Je(u), [P = !1, R] = Fe({
    prop: o,
    defaultProp: r,
    onChange: a
  }), [T, V] = Fe({
    prop: i,
    defaultProp: c,
    onChange: l
  }), k = s.useRef(null), F = S ? h || !!S.closest("form") : !0, [j, Y] = s.useState(/* @__PURE__ */ new Set()), G = Array.from(j).map(($) => $.props.value).join(";");
  return /* @__PURE__ */ f(Tl, { ...v, children: /* @__PURE__ */ ve(
    Wl,
    {
      required: g,
      scope: t,
      trigger: S,
      onTriggerChange: w,
      valueNode: y,
      onValueNodeChange: C,
      valueNodeHasChildren: N,
      onValueNodeHasChildrenChange: z,
      contentId: Pe(),
      value: T,
      onValueChange: V,
      open: P,
      onOpenChange: R,
      dir: M,
      triggerPointerDownPosRef: k,
      disabled: p,
      children: [
        /* @__PURE__ */ f(Lt.Provider, { scope: t, children: /* @__PURE__ */ f(
          Ul,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: s.useCallback(($) => {
              Y((J) => new Set(J).add($));
            }, []),
            onNativeOptionRemove: s.useCallback(($) => {
              Y((J) => {
                const K = new Set(J);
                return K.delete($), K;
              });
            }, []),
            children: n
          }
        ) }),
        F ? /* @__PURE__ */ ve(
          Ma,
          {
            "aria-hidden": !0,
            required: g,
            tabIndex: -1,
            name: m,
            autoComplete: d,
            value: T,
            onChange: ($) => V($.target.value),
            disabled: p,
            form: h,
            children: [
              T === void 0 ? /* @__PURE__ */ f("option", { value: "" }) : null,
              Array.from(j)
            ]
          },
          G
        ) : null
      ]
    }
  ) });
};
oa.displayName = vt;
var ra = "SelectTrigger", aa = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: o = !1, ...r } = e, a = kt(n), i = Te(ra, n), c = i.disabled || o, l = de(t, i.onTriggerChange), u = zt(n), m = s.useRef("touch"), [d, p, g] = Ia((v) => {
      const S = u().filter((C) => !C.disabled), w = S.find((C) => C.value === i.value), y = _a(S, v, w);
      y !== void 0 && i.onValueChange(y.value);
    }), h = (v) => {
      c || (i.onOpenChange(!0), g()), v && (i.triggerPointerDownPosRef.current = {
        x: Math.round(v.pageX),
        y: Math.round(v.pageY)
      });
    };
    return /* @__PURE__ */ f(Dl, { asChild: !0, ...a, children: /* @__PURE__ */ f(
      ce.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: c,
        "data-disabled": c ? "" : void 0,
        "data-placeholder": Aa(i.value) ? "" : void 0,
        ...r,
        ref: l,
        onClick: ae(r.onClick, (v) => {
          v.currentTarget.focus(), m.current !== "mouse" && h(v);
        }),
        onPointerDown: ae(r.onPointerDown, (v) => {
          m.current = v.pointerType;
          const S = v.target;
          S.hasPointerCapture(v.pointerId) && S.releasePointerCapture(v.pointerId), v.button === 0 && v.ctrlKey === !1 && v.pointerType === "mouse" && (h(v), v.preventDefault());
        }),
        onKeyDown: ae(r.onKeyDown, (v) => {
          const S = d.current !== "";
          !(v.ctrlKey || v.altKey || v.metaKey) && v.key.length === 1 && p(v.key), !(S && v.key === " ") && kl.includes(v.key) && (h(), v.preventDefault());
        })
      }
    ) });
  }
);
aa.displayName = ra;
var ia = "SelectValue", sa = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, children: a, placeholder: i = "", ...c } = e, l = Te(ia, n), { onValueNodeHasChildrenChange: u } = l, m = a !== void 0, d = de(t, l.onValueNodeChange);
    return oe(() => {
      u(m);
    }, [u, m]), /* @__PURE__ */ f(
      ce.span,
      {
        ...c,
        ref: d,
        style: { pointerEvents: "none" },
        children: Aa(l.value) ? /* @__PURE__ */ f(Ae, { children: i }) : a
      }
    );
  }
);
sa.displayName = ia;
var Hl = "SelectIcon", ca = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: o, ...r } = e;
    return /* @__PURE__ */ f(ce.span, { "aria-hidden": !0, ...r, ref: t, children: o || "▼" });
  }
);
ca.displayName = Hl;
var Gl = "SelectPortal", la = (e) => /* @__PURE__ */ f(mo, { asChild: !0, ...e });
la.displayName = Gl;
var Ve = "SelectContent", ua = s.forwardRef(
  (e, t) => {
    const n = Te(Ve, e.__scopeSelect), [o, r] = s.useState();
    if (oe(() => {
      r(new DocumentFragment());
    }, []), !n.open) {
      const a = o;
      return a ? fn.createPortal(
        /* @__PURE__ */ f(da, { scope: e.__scopeSelect, children: /* @__PURE__ */ f(Lt.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ f("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ f(fa, { ...e, ref: t });
  }
);
ua.displayName = Ve;
var ye = 10, [da, De] = Qe(Ve), Kl = "SelectContentImpl", fa = s.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: o = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: c,
      sideOffset: l,
      align: u,
      alignOffset: m,
      arrowPadding: d,
      collisionBoundary: p,
      collisionPadding: g,
      sticky: h,
      hideWhenDetached: v,
      avoidCollisions: S,
      //
      ...w
    } = e, y = Te(Ve, n), [C, N] = s.useState(null), [z, M] = s.useState(null), P = de(t, (b) => N(b)), [R, T] = s.useState(null), [V, k] = s.useState(
      null
    ), F = zt(n), [j, Y] = s.useState(!1), G = s.useRef(!1);
    s.useEffect(() => {
      if (C)
        return co(C);
    }, [C]), lo();
    const $ = s.useCallback(
      (b) => {
        const [E, ...D] = F().map((U) => U.ref.current), [O] = D.slice(-1), W = document.activeElement;
        for (const U of b)
          if (U === W || (U == null || U.scrollIntoView({ block: "nearest" }), U === E && z && (z.scrollTop = 0), U === O && z && (z.scrollTop = z.scrollHeight), U == null || U.focus(), document.activeElement !== W))
            return;
      },
      [F, z]
    ), J = s.useCallback(
      () => $([R, C]),
      [$, R, C]
    );
    s.useEffect(() => {
      j && J();
    }, [j, J]);
    const { onOpenChange: K, triggerPointerDownPosRef: A } = y;
    s.useEffect(() => {
      if (C) {
        let b = { x: 0, y: 0 };
        const E = (O) => {
          var W, U;
          b = {
            x: Math.abs(Math.round(O.pageX) - (((W = A.current) == null ? void 0 : W.x) ?? 0)),
            y: Math.abs(Math.round(O.pageY) - (((U = A.current) == null ? void 0 : U.y) ?? 0))
          };
        }, D = (O) => {
          b.x <= 10 && b.y <= 10 ? O.preventDefault() : C.contains(O.target) || K(!1), document.removeEventListener("pointermove", E), A.current = null;
        };
        return A.current !== null && (document.addEventListener("pointermove", E), document.addEventListener("pointerup", D, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", E), document.removeEventListener("pointerup", D, { capture: !0 });
        };
      }
    }, [C, K, A]), s.useEffect(() => {
      const b = () => K(!1);
      return window.addEventListener("blur", b), window.addEventListener("resize", b), () => {
        window.removeEventListener("blur", b), window.removeEventListener("resize", b);
      };
    }, [K]);
    const [Q, q] = Ia((b) => {
      const E = F().filter((W) => !W.disabled), D = E.find((W) => W.ref.current === document.activeElement), O = _a(E, b, D);
      O && setTimeout(() => O.ref.current.focus());
    }), te = s.useCallback(
      (b, E, D) => {
        const O = !G.current && !D;
        (y.value !== void 0 && y.value === E || O) && (T(b), O && (G.current = !0));
      },
      [y.value]
    ), x = s.useCallback(() => C == null ? void 0 : C.focus(), [C]), I = s.useCallback(
      (b, E, D) => {
        const O = !G.current && !D;
        (y.value !== void 0 && y.value === E || O) && k(b);
      },
      [y.value]
    ), L = o === "popper" ? nn : pa, _ = L === nn ? {
      side: c,
      sideOffset: l,
      align: u,
      alignOffset: m,
      arrowPadding: d,
      collisionBoundary: p,
      collisionPadding: g,
      sticky: h,
      hideWhenDetached: v,
      avoidCollisions: S
    } : {};
    return /* @__PURE__ */ f(
      da,
      {
        scope: n,
        content: C,
        viewport: z,
        onViewportChange: M,
        itemRefCallback: te,
        selectedItem: R,
        onItemLeave: x,
        itemTextRefCallback: I,
        focusSelectedItem: J,
        selectedItemText: V,
        position: o,
        isPositioned: j,
        searchRef: Q,
        children: /* @__PURE__ */ f(po, { as: ut, allowPinchZoom: !0, children: /* @__PURE__ */ f(
          uo,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (b) => {
              b.preventDefault();
            },
            onUnmountAutoFocus: ae(r, (b) => {
              var E;
              (E = y.trigger) == null || E.focus({ preventScroll: !0 }), b.preventDefault();
            }),
            children: /* @__PURE__ */ f(
              fo,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: i,
                onFocusOutside: (b) => b.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ f(
                  L,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (b) => b.preventDefault(),
                    ...w,
                    ..._,
                    onPlaced: () => Y(!0),
                    ref: P,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: ae(w.onKeyDown, (b) => {
                      const E = b.ctrlKey || b.altKey || b.metaKey;
                      if (b.key === "Tab" && b.preventDefault(), !E && b.key.length === 1 && q(b.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(b.key)) {
                        let O = F().filter((W) => !W.disabled).map((W) => W.ref.current);
                        if (["ArrowUp", "End"].includes(b.key) && (O = O.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(b.key)) {
                          const W = b.target, U = O.indexOf(W);
                          O = O.slice(U + 1);
                        }
                        setTimeout(() => $(O)), b.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
fa.displayName = Kl;
var Yl = "SelectItemAlignedPosition", pa = s.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...r } = e, a = Te(Ve, n), i = De(Ve, n), [c, l] = s.useState(null), [u, m] = s.useState(null), d = de(t, (P) => m(P)), p = zt(n), g = s.useRef(!1), h = s.useRef(!0), { viewport: v, selectedItem: S, selectedItemText: w, focusSelectedItem: y } = i, C = s.useCallback(() => {
    if (a.trigger && a.valueNode && c && u && v && S && w) {
      const P = a.trigger.getBoundingClientRect(), R = u.getBoundingClientRect(), T = a.valueNode.getBoundingClientRect(), V = w.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const W = V.left - R.left, U = T.left - W, B = P.left - U, ee = P.width + B, fe = Math.max(ee, R.width), me = window.innerWidth - ye, Se = en(U, [
          ye,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(ye, me - fe)
        ]);
        c.style.minWidth = ee + "px", c.style.left = Se + "px";
      } else {
        const W = R.right - V.right, U = window.innerWidth - T.right - W, B = window.innerWidth - P.right - U, ee = P.width + B, fe = Math.max(ee, R.width), me = window.innerWidth - ye, Se = en(U, [
          ye,
          Math.max(ye, me - fe)
        ]);
        c.style.minWidth = ee + "px", c.style.right = Se + "px";
      }
      const k = p(), F = window.innerHeight - ye * 2, j = v.scrollHeight, Y = window.getComputedStyle(u), G = parseInt(Y.borderTopWidth, 10), $ = parseInt(Y.paddingTop, 10), J = parseInt(Y.borderBottomWidth, 10), K = parseInt(Y.paddingBottom, 10), A = G + $ + j + K + J, Q = Math.min(S.offsetHeight * 5, A), q = window.getComputedStyle(v), te = parseInt(q.paddingTop, 10), x = parseInt(q.paddingBottom, 10), I = P.top + P.height / 2 - ye, L = F - I, _ = S.offsetHeight / 2, b = S.offsetTop + _, E = G + $ + b, D = A - E;
      if (E <= I) {
        const W = k.length > 0 && S === k[k.length - 1].ref.current;
        c.style.bottom = "0px";
        const U = u.clientHeight - v.offsetTop - v.offsetHeight, B = Math.max(
          L,
          _ + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (W ? x : 0) + U + J
        ), ee = E + B;
        c.style.height = ee + "px";
      } else {
        const W = k.length > 0 && S === k[0].ref.current;
        c.style.top = "0px";
        const B = Math.max(
          I,
          G + v.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (W ? te : 0) + _
        ) + D;
        c.style.height = B + "px", v.scrollTop = E - I + v.offsetTop;
      }
      c.style.margin = `${ye}px 0`, c.style.minHeight = Q + "px", c.style.maxHeight = F + "px", o == null || o(), requestAnimationFrame(() => g.current = !0);
    }
  }, [
    p,
    a.trigger,
    a.valueNode,
    c,
    u,
    v,
    S,
    w,
    a.dir,
    o
  ]);
  oe(() => C(), [C]);
  const [N, z] = s.useState();
  oe(() => {
    u && z(window.getComputedStyle(u).zIndex);
  }, [u]);
  const M = s.useCallback(
    (P) => {
      P && h.current === !0 && (C(), y == null || y(), h.current = !1);
    },
    [C, y]
  );
  return /* @__PURE__ */ f(
    Xl,
    {
      scope: n,
      contentWrapper: c,
      shouldExpandOnScrollRef: g,
      onScrollButtonChange: M,
      children: /* @__PURE__ */ f(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: N
          },
          children: /* @__PURE__ */ f(
            ce.div,
            {
              ...r,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
pa.displayName = Yl;
var jl = "SelectPopperPosition", nn = s.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: o = "start",
    collisionPadding: r = ye,
    ...a
  } = e, i = kt(n);
  return /* @__PURE__ */ f(
    Ol,
    {
      ...i,
      ...a,
      ref: t,
      align: o,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
nn.displayName = jl;
var [Xl, An] = Qe(Ve, {}), on = "SelectViewport", ma = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: o, ...r } = e, a = De(on, n), i = An(on, n), c = de(t, a.onViewportChange), l = s.useRef(0);
    return /* @__PURE__ */ ve(Ae, { children: [
      /* @__PURE__ */ f(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ f(Lt.Slot, { scope: n, children: /* @__PURE__ */ f(
        ce.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: c,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: ae(r.onScroll, (u) => {
            const m = u.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: p } = i;
            if (p != null && p.current && d) {
              const g = Math.abs(l.current - m.scrollTop);
              if (g > 0) {
                const h = window.innerHeight - ye * 2, v = parseFloat(d.style.minHeight), S = parseFloat(d.style.height), w = Math.max(v, S);
                if (w < h) {
                  const y = w + g, C = Math.min(h, y), N = y - C;
                  d.style.height = C + "px", d.style.bottom === "0px" && (m.scrollTop = N > 0 ? N : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = m.scrollTop;
          })
        }
      ) })
    ] });
  }
);
ma.displayName = on;
var ha = "SelectGroup", [ql, Zl] = Qe(ha), ga = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Pe();
    return /* @__PURE__ */ f(ql, { scope: n, id: r, children: /* @__PURE__ */ f(ce.div, { role: "group", "aria-labelledby": r, ...o, ref: t }) });
  }
);
ga.displayName = ha;
var va = "SelectLabel", wa = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Zl(va, n);
    return /* @__PURE__ */ f(ce.div, { id: r.id, ...o, ref: t });
  }
);
wa.displayName = va;
var Et = "SelectItem", [Jl, Sa] = Qe(Et), ya = s.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: o,
      disabled: r = !1,
      textValue: a,
      ...i
    } = e, c = Te(Et, n), l = De(Et, n), u = c.value === o, [m, d] = s.useState(a ?? ""), [p, g] = s.useState(!1), h = de(
      t,
      (y) => {
        var C;
        return (C = l.itemRefCallback) == null ? void 0 : C.call(l, y, o, r);
      }
    ), v = Pe(), S = s.useRef("touch"), w = () => {
      r || (c.onValueChange(o), c.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ f(
      Jl,
      {
        scope: n,
        value: o,
        disabled: r,
        textId: v,
        isSelected: u,
        onItemTextChange: s.useCallback((y) => {
          d((C) => C || ((y == null ? void 0 : y.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ f(
          Lt.ItemSlot,
          {
            scope: n,
            value: o,
            disabled: r,
            textValue: m,
            children: /* @__PURE__ */ f(
              ce.div,
              {
                role: "option",
                "aria-labelledby": v,
                "data-highlighted": p ? "" : void 0,
                "aria-selected": u && p,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...i,
                ref: h,
                onFocus: ae(i.onFocus, () => g(!0)),
                onBlur: ae(i.onBlur, () => g(!1)),
                onClick: ae(i.onClick, () => {
                  S.current !== "mouse" && w();
                }),
                onPointerUp: ae(i.onPointerUp, () => {
                  S.current === "mouse" && w();
                }),
                onPointerDown: ae(i.onPointerDown, (y) => {
                  S.current = y.pointerType;
                }),
                onPointerMove: ae(i.onPointerMove, (y) => {
                  var C;
                  S.current = y.pointerType, r ? (C = l.onItemLeave) == null || C.call(l) : S.current === "mouse" && y.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ae(i.onPointerLeave, (y) => {
                  var C;
                  y.currentTarget === document.activeElement && ((C = l.onItemLeave) == null || C.call(l));
                }),
                onKeyDown: ae(i.onKeyDown, (y) => {
                  var N;
                  ((N = l.searchRef) == null ? void 0 : N.current) !== "" && y.key === " " || (Fl.includes(y.key) && w(), y.key === " " && y.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
ya.displayName = Et;
var rt = "SelectItemText", ba = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, ...a } = e, i = Te(rt, n), c = De(rt, n), l = Sa(rt, n), u = Bl(rt, n), [m, d] = s.useState(null), p = de(
      t,
      (w) => d(w),
      l.onItemTextChange,
      (w) => {
        var y;
        return (y = c.itemTextRefCallback) == null ? void 0 : y.call(c, w, l.value, l.disabled);
      }
    ), g = m == null ? void 0 : m.textContent, h = s.useMemo(
      () => /* @__PURE__ */ f("option", { value: l.value, disabled: l.disabled, children: g }, l.value),
      [l.disabled, l.value, g]
    ), { onNativeOptionAdd: v, onNativeOptionRemove: S } = u;
    return oe(() => (v(h), () => S(h)), [v, S, h]), /* @__PURE__ */ ve(Ae, { children: [
      /* @__PURE__ */ f(ce.span, { id: l.textId, ...a, ref: p }),
      l.isSelected && i.valueNode && !i.valueNodeHasChildren ? fn.createPortal(a.children, i.valueNode) : null
    ] });
  }
);
ba.displayName = rt;
var Ca = "SelectItemIndicator", xa = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return Sa(Ca, n).isSelected ? /* @__PURE__ */ f(ce.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
xa.displayName = Ca;
var rn = "SelectScrollUpButton", Pa = s.forwardRef((e, t) => {
  const n = De(rn, e.__scopeSelect), o = An(rn, e.__scopeSelect), [r, a] = s.useState(!1), i = de(t, o.onScrollButtonChange);
  return oe(() => {
    if (n.viewport && n.isPositioned) {
      let c = function() {
        const u = l.scrollTop > 0;
        a(u);
      };
      const l = n.viewport;
      return c(), l.addEventListener("scroll", c), () => l.removeEventListener("scroll", c);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ f(
    Na,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: l } = n;
        c && l && (c.scrollTop = c.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
Pa.displayName = rn;
var an = "SelectScrollDownButton", Ra = s.forwardRef((e, t) => {
  const n = De(an, e.__scopeSelect), o = An(an, e.__scopeSelect), [r, a] = s.useState(!1), i = de(t, o.onScrollButtonChange);
  return oe(() => {
    if (n.viewport && n.isPositioned) {
      let c = function() {
        const u = l.scrollHeight - l.clientHeight, m = Math.ceil(l.scrollTop) < u;
        a(m);
      };
      const l = n.viewport;
      return c(), l.addEventListener("scroll", c), () => l.removeEventListener("scroll", c);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ f(
    Na,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: l } = n;
        c && l && (c.scrollTop = c.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
Ra.displayName = an;
var Na = s.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...r } = e, a = De("SelectScrollButton", n), i = s.useRef(null), c = zt(n), l = s.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return s.useEffect(() => () => l(), [l]), oe(() => {
    var m;
    const u = c().find((d) => d.ref.current === document.activeElement);
    (m = u == null ? void 0 : u.ref.current) == null || m.scrollIntoView({ block: "nearest" });
  }, [c]), /* @__PURE__ */ f(
    ce.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: t,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: ae(r.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerMove: ae(r.onPointerMove, () => {
        var u;
        (u = a.onItemLeave) == null || u.call(a), i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerLeave: ae(r.onPointerLeave, () => {
        l();
      })
    }
  );
}), Ql = "SelectSeparator", Ea = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return /* @__PURE__ */ f(ce.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
Ea.displayName = Ql;
var sn = "SelectArrow", eu = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = kt(n), a = Te(sn, n), i = De(sn, n);
    return a.open && i.position === "popper" ? /* @__PURE__ */ f($l, { ...r, ...o, ref: t }) : null;
  }
);
eu.displayName = sn;
function Aa(e) {
  return e === "" || e === void 0;
}
var Ma = s.forwardRef(
  (e, t) => {
    const { value: n, ...o } = e, r = s.useRef(null), a = de(t, r), i = Ll(n);
    return s.useEffect(() => {
      const c = r.current, l = window.HTMLSelectElement.prototype, m = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (i !== n && m) {
        const d = new Event("change", { bubbles: !0 });
        m.call(c, n), c.dispatchEvent(d);
      }
    }, [i, n]), /* @__PURE__ */ f(na, { asChild: !0, children: /* @__PURE__ */ f("select", { ...o, ref: a, defaultValue: n }) });
  }
);
Ma.displayName = "BubbleSelect";
function Ia(e) {
  const t = ie(e), n = s.useRef(""), o = s.useRef(0), r = s.useCallback(
    (i) => {
      const c = n.current + i;
      t(c), function l(u) {
        n.current = u, window.clearTimeout(o.current), u !== "" && (o.current = window.setTimeout(() => l(""), 1e3));
      }(c);
    },
    [t]
  ), a = s.useCallback(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return s.useEffect(() => () => window.clearTimeout(o.current), []), [n, r, a];
}
function _a(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = tu(e, Math.max(a, 0));
  r.length === 1 && (i = i.filter((u) => u !== n));
  const l = i.find(
    (u) => u.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function tu(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var nu = oa, Ta = aa, ou = sa, ru = ca, au = la, Da = ua, iu = ma, su = ga, Oa = wa, $a = ya, cu = ba, lu = xa, La = Pa, za = Ra, ka = Ea;
const ef = nu, tf = su, nf = ou, uu = s.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ ve(
  Ta,
  {
    ref: o,
    className: Z(
      "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ f(ru, { asChild: !0, children: /* @__PURE__ */ f(go, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
uu.displayName = Ta.displayName;
const Fa = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  La,
  {
    ref: n,
    className: Z(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ f(qi, { className: "h-4 w-4" })
  }
));
Fa.displayName = La.displayName;
const Va = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  za,
  {
    ref: n,
    className: Z(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ f(go, { className: "h-4 w-4" })
  }
));
Va.displayName = za.displayName;
const du = s.forwardRef(({ className: e, children: t, position: n = "popper", ...o }, r) => /* @__PURE__ */ f(au, { children: /* @__PURE__ */ ve(
  Da,
  {
    ref: r,
    className: Z(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...o,
    children: [
      /* @__PURE__ */ f(Fa, {}),
      /* @__PURE__ */ f(
        iu,
        {
          className: Z(
            "p-1",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ f(Va, {})
    ]
  }
) }));
du.displayName = Da.displayName;
const fu = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Oa,
  {
    ref: n,
    className: Z("py-1.5 pl-8 pr-2 text-sm font-semibold", e),
    ...t
  }
));
fu.displayName = Oa.displayName;
const pu = s.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ ve(
  $a,
  {
    ref: o,
    className: Z(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ f("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ f(lu, { children: /* @__PURE__ */ f(ho, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ f(cu, { children: t })
    ]
  }
));
pu.displayName = $a.displayName;
const mu = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  ka,
  {
    ref: n,
    className: Z("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
mu.displayName = ka.displayName;
function hu(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Wa(...e) {
  return (t) => e.forEach((n) => hu(n, t));
}
function Be(...e) {
  return s.useCallback(Wa(...e), e);
}
var Ua = s.forwardRef((e, t) => {
  const { children: n, ...o } = e, r = s.Children.toArray(n), a = r.find(vu);
  if (a) {
    const i = a.props.children, c = r.map((l) => l === a ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ f(cn, { ...o, ref: t, children: s.isValidElement(i) ? s.cloneElement(i, void 0, c) : null });
  }
  return /* @__PURE__ */ f(cn, { ...o, ref: t, children: n });
});
Ua.displayName = "Slot";
var cn = s.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (s.isValidElement(n)) {
    const r = Su(n);
    return s.cloneElement(n, {
      ...wu(o, n.props),
      // @ts-ignore
      ref: t ? Wa(t, r) : r
    });
  }
  return s.Children.count(n) > 1 ? s.Children.only(null) : null;
});
cn.displayName = "SlotClone";
var gu = ({ children: e }) => /* @__PURE__ */ f(Ae, { children: e });
function vu(e) {
  return s.isValidElement(e) && e.type === gu;
}
function wu(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...c) => {
      a(...c), r(...c);
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Su(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var yu = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], wt = yu.reduce((e, t) => {
  const n = s.forwardRef((o, r) => {
    const { asChild: a, ...i } = o, c = a ? Ua : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(c, { ...i, ref: r });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function bu(e, t) {
  return s.useReducer((n, o) => t[n][o] ?? n, e);
}
var St = (e) => {
  const { present: t, children: n } = e, o = Cu(t), r = typeof n == "function" ? n({ present: o.isPresent }) : s.Children.only(n), a = Be(o.ref, xu(r));
  return typeof n == "function" || o.isPresent ? s.cloneElement(r, { ref: a }) : null;
};
St.displayName = "Presence";
function Cu(e) {
  const [t, n] = s.useState(), o = s.useRef({}), r = s.useRef(e), a = s.useRef("none"), i = e ? "mounted" : "unmounted", [c, l] = bu(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const u = bt(o.current);
    a.current = c === "mounted" ? u : "none";
  }, [c]), oe(() => {
    const u = o.current, m = r.current;
    if (m !== e) {
      const p = a.current, g = bt(u);
      e ? l("MOUNT") : g === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(m && p !== g ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, l]), oe(() => {
    if (t) {
      let u;
      const m = t.ownerDocument.defaultView ?? window, d = (g) => {
        const v = bt(o.current).includes(g.animationName);
        if (g.target === t && v && (l("ANIMATION_END"), !r.current)) {
          const S = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = S);
          });
        }
      }, p = (g) => {
        g.target === t && (a.current = bt(o.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        m.clearTimeout(u), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: s.useCallback((u) => {
      u && (o.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function bt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function xu(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Le(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function Pu(e, t) {
  return s.useReducer((n, o) => t[n][o] ?? n, e);
}
var Mn = "ScrollArea", [Ba, of] = Ie(Mn), [Ru, we] = Ba(Mn), Ha = s.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: o = "hover",
      dir: r,
      scrollHideDelay: a = 600,
      ...i
    } = e, [c, l] = s.useState(null), [u, m] = s.useState(null), [d, p] = s.useState(null), [g, h] = s.useState(null), [v, S] = s.useState(null), [w, y] = s.useState(0), [C, N] = s.useState(0), [z, M] = s.useState(!1), [P, R] = s.useState(!1), T = Be(t, (k) => l(k)), V = Je(r);
    return /* @__PURE__ */ f(
      Ru,
      {
        scope: n,
        type: o,
        dir: V,
        scrollHideDelay: a,
        scrollArea: c,
        viewport: u,
        onViewportChange: m,
        content: d,
        onContentChange: p,
        scrollbarX: g,
        onScrollbarXChange: h,
        scrollbarXEnabled: z,
        onScrollbarXEnabledChange: M,
        scrollbarY: v,
        onScrollbarYChange: S,
        scrollbarYEnabled: P,
        onScrollbarYEnabledChange: R,
        onCornerWidthChange: y,
        onCornerHeightChange: N,
        children: /* @__PURE__ */ f(
          wt.div,
          {
            dir: V,
            ...i,
            ref: T,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": C + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Ha.displayName = Mn;
var Ga = "ScrollAreaViewport", Ka = s.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: o, nonce: r, ...a } = e, i = we(Ga, n), c = s.useRef(null), l = Be(t, c, i.onViewportChange);
    return /* @__PURE__ */ ve(Ae, { children: [
      /* @__PURE__ */ f(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ f(
        wt.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...a,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ f("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
Ka.displayName = Ga;
var Re = "ScrollAreaScrollbar", In = s.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = we(Re, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: i } = r, c = e.orientation === "horizontal";
    return s.useEffect(() => (c ? a(!0) : i(!0), () => {
      c ? a(!1) : i(!1);
    }), [c, a, i]), r.type === "hover" ? /* @__PURE__ */ f(Nu, { ...o, ref: t, forceMount: n }) : r.type === "scroll" ? /* @__PURE__ */ f(Eu, { ...o, ref: t, forceMount: n }) : r.type === "auto" ? /* @__PURE__ */ f(Ya, { ...o, ref: t, forceMount: n }) : r.type === "always" ? /* @__PURE__ */ f(_n, { ...o, ref: t }) : null;
  }
);
In.displayName = Re;
var Nu = s.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = we(Re, e.__scopeScrollArea), [a, i] = s.useState(!1);
  return s.useEffect(() => {
    const c = r.scrollArea;
    let l = 0;
    if (c) {
      const u = () => {
        window.clearTimeout(l), i(!0);
      }, m = () => {
        l = window.setTimeout(() => i(!1), r.scrollHideDelay);
      };
      return c.addEventListener("pointerenter", u), c.addEventListener("pointerleave", m), () => {
        window.clearTimeout(l), c.removeEventListener("pointerenter", u), c.removeEventListener("pointerleave", m);
      };
    }
  }, [r.scrollArea, r.scrollHideDelay]), /* @__PURE__ */ f(St, { present: n || a, children: /* @__PURE__ */ f(
    Ya,
    {
      "data-state": a ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), Eu = s.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = we(Re, e.__scopeScrollArea), a = e.orientation === "horizontal", i = Vt(() => l("SCROLL_END"), 100), [c, l] = Pu("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return s.useEffect(() => {
    if (c === "idle") {
      const u = window.setTimeout(() => l("HIDE"), r.scrollHideDelay);
      return () => window.clearTimeout(u);
    }
  }, [c, r.scrollHideDelay, l]), s.useEffect(() => {
    const u = r.viewport, m = a ? "scrollLeft" : "scrollTop";
    if (u) {
      let d = u[m];
      const p = () => {
        const g = u[m];
        d !== g && (l("SCROLL"), i()), d = g;
      };
      return u.addEventListener("scroll", p), () => u.removeEventListener("scroll", p);
    }
  }, [r.viewport, a, l, i]), /* @__PURE__ */ f(St, { present: n || c !== "hidden", children: /* @__PURE__ */ f(
    _n,
    {
      "data-state": c === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: Le(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: Le(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Ya = s.forwardRef((e, t) => {
  const n = we(Re, e.__scopeScrollArea), { forceMount: o, ...r } = e, [a, i] = s.useState(!1), c = e.orientation === "horizontal", l = Vt(() => {
    if (n.viewport) {
      const u = n.viewport.offsetWidth < n.viewport.scrollWidth, m = n.viewport.offsetHeight < n.viewport.scrollHeight;
      i(c ? u : m);
    }
  }, 10);
  return qe(n.viewport, l), qe(n.content, l), /* @__PURE__ */ f(St, { present: o || a, children: /* @__PURE__ */ f(
    _n,
    {
      "data-state": a ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), _n = s.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...o } = e, r = we(Re, e.__scopeScrollArea), a = s.useRef(null), i = s.useRef(0), [c, l] = s.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), u = Ja(c.viewport, c.content), m = {
    ...o,
    sizes: c,
    onSizesChange: l,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (p) => a.current = p,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (p) => i.current = p
  };
  function d(p, g) {
    return Du(p, i.current, c, g);
  }
  return n === "horizontal" ? /* @__PURE__ */ f(
    Au,
    {
      ...m,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && a.current) {
          const p = r.viewport.scrollLeft, g = Wn(p, c, r.dir);
          a.current.style.transform = `translate3d(${g}px, 0, 0)`;
        }
      },
      onWheelScroll: (p) => {
        r.viewport && (r.viewport.scrollLeft = p);
      },
      onDragScroll: (p) => {
        r.viewport && (r.viewport.scrollLeft = d(p, r.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ f(
    Mu,
    {
      ...m,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && a.current) {
          const p = r.viewport.scrollTop, g = Wn(p, c);
          a.current.style.transform = `translate3d(0, ${g}px, 0)`;
        }
      },
      onWheelScroll: (p) => {
        r.viewport && (r.viewport.scrollTop = p);
      },
      onDragScroll: (p) => {
        r.viewport && (r.viewport.scrollTop = d(p));
      }
    }
  ) : null;
}), Au = s.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...r } = e, a = we(Re, e.__scopeScrollArea), [i, c] = s.useState(), l = s.useRef(null), u = Be(t, l, a.onScrollbarXChange);
  return s.useEffect(() => {
    l.current && c(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ f(
    Xa,
    {
      "data-orientation": "horizontal",
      ...r,
      ref: u,
      sizes: n,
      style: {
        bottom: 0,
        left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Ft(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (m) => e.onThumbPointerDown(m.x),
      onDragScroll: (m) => e.onDragScroll(m.x),
      onWheelScroll: (m, d) => {
        if (a.viewport) {
          const p = a.viewport.scrollLeft + m.deltaX;
          e.onWheelScroll(p), ei(p, d) && m.preventDefault();
        }
      },
      onResize: () => {
        l.current && a.viewport && i && o({
          content: a.viewport.scrollWidth,
          viewport: a.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Mt(i.paddingLeft),
            paddingEnd: Mt(i.paddingRight)
          }
        });
      }
    }
  );
}), Mu = s.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...r } = e, a = we(Re, e.__scopeScrollArea), [i, c] = s.useState(), l = s.useRef(null), u = Be(t, l, a.onScrollbarYChange);
  return s.useEffect(() => {
    l.current && c(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ f(
    Xa,
    {
      "data-orientation": "vertical",
      ...r,
      ref: u,
      sizes: n,
      style: {
        top: 0,
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Ft(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (m) => e.onThumbPointerDown(m.y),
      onDragScroll: (m) => e.onDragScroll(m.y),
      onWheelScroll: (m, d) => {
        if (a.viewport) {
          const p = a.viewport.scrollTop + m.deltaY;
          e.onWheelScroll(p), ei(p, d) && m.preventDefault();
        }
      },
      onResize: () => {
        l.current && a.viewport && i && o({
          content: a.viewport.scrollHeight,
          viewport: a.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Mt(i.paddingTop),
            paddingEnd: Mt(i.paddingBottom)
          }
        });
      }
    }
  );
}), [Iu, ja] = Ba(Re), Xa = s.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: o,
    hasThumb: r,
    onThumbChange: a,
    onThumbPointerUp: i,
    onThumbPointerDown: c,
    onThumbPositionChange: l,
    onDragScroll: u,
    onWheelScroll: m,
    onResize: d,
    ...p
  } = e, g = we(Re, n), [h, v] = s.useState(null), S = Be(t, (T) => v(T)), w = s.useRef(null), y = s.useRef(""), C = g.viewport, N = o.content - o.viewport, z = ie(m), M = ie(l), P = Vt(d, 10);
  function R(T) {
    if (w.current) {
      const V = T.clientX - w.current.left, k = T.clientY - w.current.top;
      u({ x: V, y: k });
    }
  }
  return s.useEffect(() => {
    const T = (V) => {
      const k = V.target;
      (h == null ? void 0 : h.contains(k)) && z(V, N);
    };
    return document.addEventListener("wheel", T, { passive: !1 }), () => document.removeEventListener("wheel", T, { passive: !1 });
  }, [C, h, N, z]), s.useEffect(M, [o, M]), qe(h, P), qe(g.content, P), /* @__PURE__ */ f(
    Iu,
    {
      scope: n,
      scrollbar: h,
      hasThumb: r,
      onThumbChange: ie(a),
      onThumbPointerUp: ie(i),
      onThumbPositionChange: M,
      onThumbPointerDown: ie(c),
      children: /* @__PURE__ */ f(
        wt.div,
        {
          ...p,
          ref: S,
          style: { position: "absolute", ...p.style },
          onPointerDown: Le(e.onPointerDown, (T) => {
            T.button === 0 && (T.target.setPointerCapture(T.pointerId), w.current = h.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", g.viewport && (g.viewport.style.scrollBehavior = "auto"), R(T));
          }),
          onPointerMove: Le(e.onPointerMove, R),
          onPointerUp: Le(e.onPointerUp, (T) => {
            const V = T.target;
            V.hasPointerCapture(T.pointerId) && V.releasePointerCapture(T.pointerId), document.body.style.webkitUserSelect = y.current, g.viewport && (g.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), At = "ScrollAreaThumb", qa = s.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = ja(At, e.__scopeScrollArea);
    return /* @__PURE__ */ f(St, { present: n || r.hasThumb, children: /* @__PURE__ */ f(_u, { ref: t, ...o }) });
  }
), _u = s.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: o, ...r } = e, a = we(At, n), i = ja(At, n), { onThumbPositionChange: c } = i, l = Be(
      t,
      (d) => i.onThumbChange(d)
    ), u = s.useRef(), m = Vt(() => {
      u.current && (u.current(), u.current = void 0);
    }, 100);
    return s.useEffect(() => {
      const d = a.viewport;
      if (d) {
        const p = () => {
          if (m(), !u.current) {
            const g = Ou(d, c);
            u.current = g, c();
          }
        };
        return c(), d.addEventListener("scroll", p), () => d.removeEventListener("scroll", p);
      }
    }, [a.viewport, m, c]), /* @__PURE__ */ f(
      wt.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...r,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: Le(e.onPointerDownCapture, (d) => {
          const g = d.target.getBoundingClientRect(), h = d.clientX - g.left, v = d.clientY - g.top;
          i.onThumbPointerDown({ x: h, y: v });
        }),
        onPointerUp: Le(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
qa.displayName = At;
var Tn = "ScrollAreaCorner", Za = s.forwardRef(
  (e, t) => {
    const n = we(Tn, e.__scopeScrollArea), o = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && o ? /* @__PURE__ */ f(Tu, { ...e, ref: t }) : null;
  }
);
Za.displayName = Tn;
var Tu = s.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...o } = e, r = we(Tn, n), [a, i] = s.useState(0), [c, l] = s.useState(0), u = !!(a && c);
  return qe(r.scrollbarX, () => {
    var d;
    const m = ((d = r.scrollbarX) == null ? void 0 : d.offsetHeight) || 0;
    r.onCornerHeightChange(m), l(m);
  }), qe(r.scrollbarY, () => {
    var d;
    const m = ((d = r.scrollbarY) == null ? void 0 : d.offsetWidth) || 0;
    r.onCornerWidthChange(m), i(m);
  }), u ? /* @__PURE__ */ f(
    wt.div,
    {
      ...o,
      ref: t,
      style: {
        width: a,
        height: c,
        position: "absolute",
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Mt(e) {
  return e ? parseInt(e, 10) : 0;
}
function Ja(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Ft(e) {
  const t = Ja(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - n) * t;
  return Math.max(o, 18);
}
function Du(e, t, n, o = "ltr") {
  const r = Ft(n), a = r / 2, i = t || a, c = r - i, l = n.scrollbar.paddingStart + i, u = n.scrollbar.size - n.scrollbar.paddingEnd - c, m = n.content - n.viewport, d = o === "ltr" ? [0, m] : [m * -1, 0];
  return Qa([l, u], d)(e);
}
function Wn(e, t, n = "ltr") {
  const o = Ft(t), r = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - r, i = t.content - t.viewport, c = a - o, l = n === "ltr" ? [0, i] : [i * -1, 0], u = en(e, l);
  return Qa([0, i], [0, c])(u);
}
function Qa(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function ei(e, t) {
  return e > 0 && e < t;
}
var Ou = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function r() {
    const a = { left: e.scrollLeft, top: e.scrollTop }, i = n.left !== a.left, c = n.top !== a.top;
    (i || c) && t(), n = a, o = window.requestAnimationFrame(r);
  }(), () => window.cancelAnimationFrame(o);
};
function Vt(e, t) {
  const n = ie(e), o = s.useRef(0);
  return s.useEffect(() => () => window.clearTimeout(o.current), []), s.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(n, t);
  }, [n, t]);
}
function qe(e, t) {
  const n = ie(t);
  oe(() => {
    let o = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(o), r.unobserve(e);
      };
    }
  }, [e, n]);
}
var ti = Ha, $u = Ka, Lu = Za;
const zu = s.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ ve(
  ti,
  {
    ref: o,
    className: Z("relative overflow-hidden", e),
    ...n,
    children: [
      /* @__PURE__ */ f($u, { className: "h-full w-full rounded-[inherit]", children: t }),
      /* @__PURE__ */ f(ni, {}),
      /* @__PURE__ */ f(Lu, {})
    ]
  }
));
zu.displayName = ti.displayName;
const ni = s.forwardRef(({ className: e, orientation: t = "vertical", ...n }, o) => /* @__PURE__ */ f(
  In,
  {
    ref: o,
    orientation: t,
    className: Z(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ f(qa, { className: "relative flex-1 rounded-full bg-border" })
  }
));
ni.displayName = In.displayName;
function Ee(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
var It = s.forwardRef((e, t) => {
  const { children: n, ...o } = e, r = s.Children.toArray(n), a = r.find(Fu);
  if (a) {
    const i = a.props.children, c = r.map((l) => l === a ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ f(ln, { ...o, ref: t, children: s.isValidElement(i) ? s.cloneElement(i, void 0, c) : null });
  }
  return /* @__PURE__ */ f(ln, { ...o, ref: t, children: n });
});
It.displayName = "Slot";
var ln = s.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (s.isValidElement(n)) {
    const r = Wu(n);
    return s.cloneElement(n, {
      ...Vu(o, n.props),
      // @ts-ignore
      ref: t ? Zn(t, r) : r
    });
  }
  return s.Children.count(n) > 1 ? s.Children.only(null) : null;
});
ln.displayName = "SlotClone";
var ku = ({ children: e }) => /* @__PURE__ */ f(Ae, { children: e });
function Fu(e) {
  return s.isValidElement(e) && e.type === ku;
}
function Vu(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...c) => {
      a(...c), r(...c);
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Wu(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Uu(e) {
  const t = e + "CollectionProvider", [n, o] = Ie(t), [r, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (g) => {
    const { scope: h, children: v } = g, S = ne.useRef(null), w = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ f(r, { scope: h, itemMap: w, collectionRef: S, children: v });
  };
  i.displayName = t;
  const c = e + "CollectionSlot", l = ne.forwardRef(
    (g, h) => {
      const { scope: v, children: S } = g, w = a(c, v), y = Pt(h, w.collectionRef);
      return /* @__PURE__ */ f(It, { ref: y, children: S });
    }
  );
  l.displayName = c;
  const u = e + "CollectionItemSlot", m = "data-radix-collection-item", d = ne.forwardRef(
    (g, h) => {
      const { scope: v, children: S, ...w } = g, y = ne.useRef(null), C = Pt(h, y), N = a(u, v);
      return ne.useEffect(() => (N.itemMap.set(y, { ref: y, ...w }), () => void N.itemMap.delete(y))), /* @__PURE__ */ f(It, { [m]: "", ref: C, children: S });
    }
  );
  d.displayName = u;
  function p(g) {
    const h = a(e + "CollectionConsumer", g);
    return ne.useCallback(() => {
      const S = h.collectionRef.current;
      if (!S)
        return [];
      const w = Array.from(S.querySelectorAll(`[${m}]`));
      return Array.from(h.itemMap.values()).sort(
        (N, z) => w.indexOf(N.ref.current) - w.indexOf(z.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: i, Slot: l, ItemSlot: d },
    p,
    o
  ];
}
var Bu = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], et = Bu.reduce((e, t) => {
  const n = s.forwardRef((o, r) => {
    const { asChild: a, ...i } = o, c = a ? It : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(c, { ...i, ref: r });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Yt = "rovingFocusGroup.onEntryFocus", Hu = { bubbles: !1, cancelable: !0 }, Wt = "RovingFocusGroup", [un, oi, Gu] = Uu(Wt), [Ku, ri] = Ie(
  Wt,
  [Gu]
), [Yu, ju] = Ku(Wt), ai = s.forwardRef(
  (e, t) => /* @__PURE__ */ f(un.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f(un.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f(Xu, { ...e, ref: t }) }) })
);
ai.displayName = Wt;
var Xu = s.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: r = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: c,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: m = !1,
    ...d
  } = e, p = s.useRef(null), g = Pt(t, p), h = Je(a), [v = null, S] = Fe({
    prop: i,
    defaultProp: c,
    onChange: l
  }), [w, y] = s.useState(!1), C = ie(u), N = oi(n), z = s.useRef(!1), [M, P] = s.useState(0);
  return s.useEffect(() => {
    const R = p.current;
    if (R)
      return R.addEventListener(Yt, C), () => R.removeEventListener(Yt, C);
  }, [C]), /* @__PURE__ */ f(
    Yu,
    {
      scope: n,
      orientation: o,
      dir: h,
      loop: r,
      currentTabStopId: v,
      onItemFocus: s.useCallback(
        (R) => S(R),
        [S]
      ),
      onItemShiftTab: s.useCallback(() => y(!0), []),
      onFocusableItemAdd: s.useCallback(
        () => P((R) => R + 1),
        []
      ),
      onFocusableItemRemove: s.useCallback(
        () => P((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ f(
        et.div,
        {
          tabIndex: w || M === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: g,
          style: { outline: "none", ...e.style },
          onMouseDown: Ee(e.onMouseDown, () => {
            z.current = !0;
          }),
          onFocus: Ee(e.onFocus, (R) => {
            const T = !z.current;
            if (R.target === R.currentTarget && T && !w) {
              const V = new CustomEvent(Yt, Hu);
              if (R.currentTarget.dispatchEvent(V), !V.defaultPrevented) {
                const k = N().filter(($) => $.focusable), F = k.find(($) => $.active), j = k.find(($) => $.id === v), G = [F, j, ...k].filter(
                  Boolean
                ).map(($) => $.ref.current);
                ci(G, m);
              }
            }
            z.current = !1;
          }),
          onBlur: Ee(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), ii = "RovingFocusGroupItem", si = s.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: r = !1,
      tabStopId: a,
      ...i
    } = e, c = Pe(), l = a || c, u = ju(ii, n), m = u.currentTabStopId === l, d = oi(n), { onFocusableItemAdd: p, onFocusableItemRemove: g } = u;
    return s.useEffect(() => {
      if (o)
        return p(), () => g();
    }, [o, p, g]), /* @__PURE__ */ f(
      un.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: o,
        active: r,
        children: /* @__PURE__ */ f(
          et.span,
          {
            tabIndex: m ? 0 : -1,
            "data-orientation": u.orientation,
            ...i,
            ref: t,
            onMouseDown: Ee(e.onMouseDown, (h) => {
              o ? u.onItemFocus(l) : h.preventDefault();
            }),
            onFocus: Ee(e.onFocus, () => u.onItemFocus(l)),
            onKeyDown: Ee(e.onKeyDown, (h) => {
              if (h.key === "Tab" && h.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (h.target !== h.currentTarget)
                return;
              const v = Ju(h, u.orientation, u.dir);
              if (v !== void 0) {
                if (h.metaKey || h.ctrlKey || h.altKey || h.shiftKey)
                  return;
                h.preventDefault();
                let w = d().filter((y) => y.focusable).map((y) => y.ref.current);
                if (v === "last")
                  w.reverse();
                else if (v === "prev" || v === "next") {
                  v === "prev" && w.reverse();
                  const y = w.indexOf(h.currentTarget);
                  w = u.loop ? Qu(w, y + 1) : w.slice(y + 1);
                }
                setTimeout(() => ci(w));
              }
            })
          }
        )
      }
    );
  }
);
si.displayName = ii;
var qu = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Zu(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Ju(e, t, n) {
  const o = Zu(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return qu[o];
}
function ci(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n))
      return;
}
function Qu(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var ed = ai, td = si;
function nd(e, t) {
  return s.useReducer((n, o) => t[n][o] ?? n, e);
}
var li = (e) => {
  const { present: t, children: n } = e, o = od(t), r = typeof n == "function" ? n({ present: o.isPresent }) : s.Children.only(n), a = Pt(o.ref, rd(r));
  return typeof n == "function" || o.isPresent ? s.cloneElement(r, { ref: a }) : null;
};
li.displayName = "Presence";
function od(e) {
  const [t, n] = s.useState(), o = s.useRef({}), r = s.useRef(e), a = s.useRef("none"), i = e ? "mounted" : "unmounted", [c, l] = nd(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const u = Ct(o.current);
    a.current = c === "mounted" ? u : "none";
  }, [c]), oe(() => {
    const u = o.current, m = r.current;
    if (m !== e) {
      const p = a.current, g = Ct(u);
      e ? l("MOUNT") : g === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(m && p !== g ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, l]), oe(() => {
    if (t) {
      let u;
      const m = t.ownerDocument.defaultView ?? window, d = (g) => {
        const v = Ct(o.current).includes(g.animationName);
        if (g.target === t && v && (l("ANIMATION_END"), !r.current)) {
          const S = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = S);
          });
        }
      }, p = (g) => {
        g.target === t && (a.current = Ct(o.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        m.clearTimeout(u), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: s.useCallback((u) => {
      u && (o.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function Ct(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function rd(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Dn = "Tabs", [ad, rf] = Ie(Dn, [
  ri
]), ui = ri(), [id, On] = ad(Dn), di = s.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: o,
      onValueChange: r,
      defaultValue: a,
      orientation: i = "horizontal",
      dir: c,
      activationMode: l = "automatic",
      ...u
    } = e, m = Je(c), [d, p] = Fe({
      prop: o,
      onChange: r,
      defaultProp: a
    });
    return /* @__PURE__ */ f(
      id,
      {
        scope: n,
        baseId: Pe(),
        value: d,
        onValueChange: p,
        orientation: i,
        dir: m,
        activationMode: l,
        children: /* @__PURE__ */ f(
          et.div,
          {
            dir: m,
            "data-orientation": i,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
di.displayName = Dn;
var fi = "TabsList", pi = s.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: o = !0, ...r } = e, a = On(fi, n), i = ui(n);
    return /* @__PURE__ */ f(
      ed,
      {
        asChild: !0,
        ...i,
        orientation: a.orientation,
        dir: a.dir,
        loop: o,
        children: /* @__PURE__ */ f(
          et.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...r,
            ref: t
          }
        )
      }
    );
  }
);
pi.displayName = fi;
var mi = "TabsTrigger", hi = s.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, disabled: r = !1, ...a } = e, i = On(mi, n), c = ui(n), l = wi(i.baseId, o), u = Si(i.baseId, o), m = o === i.value;
    return /* @__PURE__ */ f(
      td,
      {
        asChild: !0,
        ...c,
        focusable: !r,
        active: m,
        children: /* @__PURE__ */ f(
          et.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": m,
            "aria-controls": u,
            "data-state": m ? "active" : "inactive",
            "data-disabled": r ? "" : void 0,
            disabled: r,
            id: l,
            ...a,
            ref: t,
            onMouseDown: Ee(e.onMouseDown, (d) => {
              !r && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(o) : d.preventDefault();
            }),
            onKeyDown: Ee(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && i.onValueChange(o);
            }),
            onFocus: Ee(e.onFocus, () => {
              const d = i.activationMode !== "manual";
              !m && !r && d && i.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
hi.displayName = mi;
var gi = "TabsContent", vi = s.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, forceMount: r, children: a, ...i } = e, c = On(gi, n), l = wi(c.baseId, o), u = Si(c.baseId, o), m = o === c.value, d = s.useRef(m);
    return s.useEffect(() => {
      const p = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(p);
    }, []), /* @__PURE__ */ f(li, { present: r || m, children: ({ present: p }) => /* @__PURE__ */ f(
      et.div,
      {
        "data-state": m ? "active" : "inactive",
        "data-orientation": c.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !p,
        id: u,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: p && a
      }
    ) });
  }
);
vi.displayName = gi;
function wi(e, t) {
  return `${e}-trigger-${t}`;
}
function Si(e, t) {
  return `${e}-content-${t}`;
}
var sd = di, yi = pi, bi = hi, Ci = vi;
const af = sd, cd = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  yi,
  {
    ref: n,
    className: Z(
      "inline-flex h-9 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground",
      e
    ),
    ...t
  }
));
cd.displayName = yi.displayName;
const ld = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  bi,
  {
    ref: n,
    className: Z(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
      e
    ),
    ...t
  }
));
ld.displayName = bi.displayName;
const ud = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Ci,
  {
    ref: n,
    className: Z(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
ud.displayName = Ci.displayName;
const {
  createElement: Ze,
  createContext: dd,
  createRef: sf,
  forwardRef: xi,
  useCallback: le,
  useContext: Pi,
  useEffect: ze,
  useImperativeHandle: Ri,
  useLayoutEffect: fd,
  useMemo: pd,
  useRef: ue,
  useState: je
} = s, Un = s[`useId${Math.random()}`.slice(0, 5)], md = fd, Ut = dd(null);
Ut.displayName = "PanelGroupContext";
const ke = md, hd = typeof Un == "function" ? Un : () => null;
let gd = 0;
function $n(e = null) {
  const t = hd(), n = ue(e || t || null);
  return n.current === null && (n.current = "" + gd++), e ?? n.current;
}
function Ni({
  children: e,
  className: t = "",
  collapsedSize: n,
  collapsible: o,
  defaultSize: r,
  forwardedRef: a,
  id: i,
  maxSize: c,
  minSize: l,
  onCollapse: u,
  onExpand: m,
  onResize: d,
  order: p,
  style: g,
  tagName: h = "div",
  ...v
}) {
  const S = Pi(Ut);
  if (S === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const {
    collapsePanel: w,
    expandPanel: y,
    getPanelSize: C,
    getPanelStyle: N,
    groupId: z,
    isPanelCollapsed: M,
    reevaluatePanelConstraints: P,
    registerPanel: R,
    resizePanel: T,
    unregisterPanel: V
  } = S, k = $n(i), F = ue({
    callbacks: {
      onCollapse: u,
      onExpand: m,
      onResize: d
    },
    constraints: {
      collapsedSize: n,
      collapsible: o,
      defaultSize: r,
      maxSize: c,
      minSize: l
    },
    id: k,
    idIsFromProps: i !== void 0,
    order: p
  });
  ue({
    didLogMissingDefaultSizeWarning: !1
  }), ke(() => {
    const {
      callbacks: Y,
      constraints: G
    } = F.current, $ = {
      ...G
    };
    F.current.id = k, F.current.idIsFromProps = i !== void 0, F.current.order = p, Y.onCollapse = u, Y.onExpand = m, Y.onResize = d, G.collapsedSize = n, G.collapsible = o, G.defaultSize = r, G.maxSize = c, G.minSize = l, ($.collapsedSize !== G.collapsedSize || $.collapsible !== G.collapsible || $.maxSize !== G.maxSize || $.minSize !== G.minSize) && P(F.current, $);
  }), ke(() => {
    const Y = F.current;
    return R(Y), () => {
      V(Y);
    };
  }, [p, k, R, V]), Ri(a, () => ({
    collapse: () => {
      w(F.current);
    },
    expand: (Y) => {
      y(F.current, Y);
    },
    getId() {
      return k;
    },
    getSize() {
      return C(F.current);
    },
    isCollapsed() {
      return M(F.current);
    },
    isExpanded() {
      return !M(F.current);
    },
    resize: (Y) => {
      T(F.current, Y);
    }
  }), [w, y, C, M, k, T]);
  const j = N(F.current, r);
  return Ze(h, {
    ...v,
    children: e,
    className: t,
    id: i,
    style: {
      ...j,
      ...g
    },
    // CSS selectors
    "data-panel": "",
    "data-panel-collapsible": o || void 0,
    "data-panel-group-id": z,
    "data-panel-id": k,
    "data-panel-size": parseFloat("" + j.flexGrow).toFixed(1)
  });
}
const Ei = xi((e, t) => Ze(Ni, {
  ...e,
  forwardedRef: t
}));
Ni.displayName = "Panel";
Ei.displayName = "forwardRef(Panel)";
let dn = null, $e = null;
function vd(e, t) {
  if (t) {
    const n = (t & Ti) !== 0, o = (t & Di) !== 0, r = (t & Oi) !== 0, a = (t & $i) !== 0;
    if (n)
      return r ? "se-resize" : a ? "ne-resize" : "e-resize";
    if (o)
      return r ? "sw-resize" : a ? "nw-resize" : "w-resize";
    if (r)
      return "s-resize";
    if (a)
      return "n-resize";
  }
  switch (e) {
    case "horizontal":
      return "ew-resize";
    case "intersection":
      return "move";
    case "vertical":
      return "ns-resize";
  }
}
function wd() {
  $e !== null && (document.head.removeChild($e), dn = null, $e = null);
}
function jt(e, t) {
  const n = vd(e, t);
  dn !== n && (dn = n, $e === null && ($e = document.createElement("style"), document.head.appendChild($e)), $e.innerHTML = `*{cursor: ${n}!important;}`);
}
function Ai(e) {
  return e.type === "keydown";
}
function Mi(e) {
  return e.type.startsWith("pointer");
}
function Ii(e) {
  return e.type.startsWith("mouse");
}
function Bt(e) {
  if (Mi(e)) {
    if (e.isPrimary)
      return {
        x: e.clientX,
        y: e.clientY
      };
  } else if (Ii(e))
    return {
      x: e.clientX,
      y: e.clientY
    };
  return {
    x: 1 / 0,
    y: 1 / 0
  };
}
function Sd() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
function yd(e, t, n) {
  return n ? e.x < t.x + t.width && e.x + e.width > t.x && e.y < t.y + t.height && e.y + e.height > t.y : e.x <= t.x + t.width && e.x + e.width >= t.x && e.y <= t.y + t.height && e.y + e.height >= t.y;
}
function bd(e, t) {
  if (e === t)
    throw new Error("Cannot compare node with itself");
  const n = {
    a: Gn(e),
    b: Gn(t)
  };
  let o;
  for (; n.a.at(-1) === n.b.at(-1); )
    e = n.a.pop(), t = n.b.pop(), o = e;
  H(o, "Stacking order can only be calculated for elements with a common ancestor");
  const r = {
    a: Hn(Bn(n.a)),
    b: Hn(Bn(n.b))
  };
  if (r.a === r.b) {
    const a = o.childNodes, i = {
      a: n.a.at(-1),
      b: n.b.at(-1)
    };
    let c = a.length;
    for (; c--; ) {
      const l = a[c];
      if (l === i.a)
        return 1;
      if (l === i.b)
        return -1;
    }
  }
  return Math.sign(r.a - r.b);
}
const Cd = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function xd(e) {
  var t;
  const n = getComputedStyle((t = _i(e)) !== null && t !== void 0 ? t : e).display;
  return n === "flex" || n === "inline-flex";
}
function Pd(e) {
  const t = getComputedStyle(e);
  return !!(t.position === "fixed" || t.zIndex !== "auto" && (t.position !== "static" || xd(e)) || +t.opacity < 1 || "transform" in t && t.transform !== "none" || "webkitTransform" in t && t.webkitTransform !== "none" || "mixBlendMode" in t && t.mixBlendMode !== "normal" || "filter" in t && t.filter !== "none" || "webkitFilter" in t && t.webkitFilter !== "none" || "isolation" in t && t.isolation === "isolate" || Cd.test(t.willChange) || t.webkitOverflowScrolling === "touch");
}
function Bn(e) {
  let t = e.length;
  for (; t--; ) {
    const n = e[t];
    if (H(n, "Missing node"), Pd(n))
      return n;
  }
  return null;
}
function Hn(e) {
  return e && Number(getComputedStyle(e).zIndex) || 0;
}
function Gn(e) {
  const t = [];
  for (; e; )
    t.push(e), e = _i(e);
  return t;
}
function _i(e) {
  const {
    parentNode: t
  } = e;
  return t && t instanceof ShadowRoot ? t.host : t;
}
const Ti = 1, Di = 2, Oi = 4, $i = 8, Rd = Sd() === "coarse";
let be = [], Xe = !1, Me = /* @__PURE__ */ new Map(), Ht = /* @__PURE__ */ new Map();
const dt = /* @__PURE__ */ new Set();
function Nd(e, t, n, o, r) {
  var a;
  const {
    ownerDocument: i
  } = t, c = {
    direction: n,
    element: t,
    hitAreaMargins: o,
    setResizeHandlerState: r
  }, l = (a = Me.get(i)) !== null && a !== void 0 ? a : 0;
  return Me.set(i, l + 1), dt.add(c), _t(), function() {
    var m;
    Ht.delete(e), dt.delete(c);
    const d = (m = Me.get(i)) !== null && m !== void 0 ? m : 1;
    if (Me.set(i, d - 1), _t(), d === 1 && Me.delete(i), be.includes(c)) {
      const p = be.indexOf(c);
      p >= 0 && be.splice(p, 1), zn(), r("up", !0, null);
    }
  };
}
function Kn(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: o
  } = Bt(e);
  Xe = !0, Ln({
    target: t,
    x: n,
    y: o
  }), _t(), be.length > 0 && (Tt("down", e), e.preventDefault(), e.stopPropagation());
}
function nt(e) {
  const {
    x: t,
    y: n
  } = Bt(e);
  if (Xe && e.buttons === 0 && (Xe = !1, Tt("up", e)), !Xe) {
    const {
      target: o
    } = e;
    Ln({
      target: o,
      x: t,
      y: n
    });
  }
  Tt("move", e), zn(), be.length > 0 && e.preventDefault();
}
function He(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: o
  } = Bt(e);
  Ht.clear(), Xe = !1, be.length > 0 && e.preventDefault(), Tt("up", e), Ln({
    target: t,
    x: n,
    y: o
  }), zn(), _t();
}
function Ln({
  target: e,
  x: t,
  y: n
}) {
  be.splice(0);
  let o = null;
  (e instanceof HTMLElement || e instanceof SVGElement) && (o = e), dt.forEach((r) => {
    const {
      element: a,
      hitAreaMargins: i
    } = r, c = a.getBoundingClientRect(), {
      bottom: l,
      left: u,
      right: m,
      top: d
    } = c, p = Rd ? i.coarse : i.fine;
    if (t >= u - p && t <= m + p && n >= d - p && n <= l + p) {
      if (o !== null && document.contains(o) && a !== o && !a.contains(o) && !o.contains(a) && // Calculating stacking order has a cost, so we should avoid it if possible
      // That is why we only check potentially intersecting handles,
      // and why we skip if the event target is within the handle's DOM
      bd(o, a) > 0) {
        let h = o, v = !1;
        for (; h && !h.contains(a); ) {
          if (yd(h.getBoundingClientRect(), c, !0)) {
            v = !0;
            break;
          }
          h = h.parentElement;
        }
        if (v)
          return;
      }
      be.push(r);
    }
  });
}
function Xt(e, t) {
  Ht.set(e, t);
}
function zn() {
  let e = !1, t = !1;
  be.forEach((o) => {
    const {
      direction: r
    } = o;
    r === "horizontal" ? e = !0 : t = !0;
  });
  let n = 0;
  Ht.forEach((o) => {
    n |= o;
  }), e && t ? jt("intersection", n) : e ? jt("horizontal", n) : t ? jt("vertical", n) : wd();
}
function _t() {
  Me.forEach((e, t) => {
    const {
      body: n
    } = t;
    n.removeEventListener("contextmenu", He), n.removeEventListener("pointerdown", Kn), n.removeEventListener("pointerleave", nt), n.removeEventListener("pointermove", nt);
  }), window.removeEventListener("pointerup", He), window.removeEventListener("pointercancel", He), dt.size > 0 && (Xe ? (be.length > 0 && Me.forEach((e, t) => {
    const {
      body: n
    } = t;
    e > 0 && (n.addEventListener("contextmenu", He), n.addEventListener("pointerleave", nt), n.addEventListener("pointermove", nt));
  }), window.addEventListener("pointerup", He), window.addEventListener("pointercancel", He)) : Me.forEach((e, t) => {
    const {
      body: n
    } = t;
    e > 0 && (n.addEventListener("pointerdown", Kn, {
      capture: !0
    }), n.addEventListener("pointermove", nt));
  }));
}
function Tt(e, t) {
  dt.forEach((n) => {
    const {
      setResizeHandlerState: o
    } = n, r = be.includes(n);
    o(e, r, t);
  });
}
function Ed() {
  const [e, t] = je(0);
  return le(() => t((n) => n + 1), []);
}
function H(e, t) {
  if (!e)
    throw console.error(t), Error(t);
}
const kn = 10;
function We(e, t, n = kn) {
  return e.toFixed(n) === t.toFixed(n) ? 0 : e > t ? 1 : -1;
}
function Ne(e, t, n = kn) {
  return We(e, t, n) === 0;
}
function pe(e, t, n) {
  return We(e, t, n) === 0;
}
function Ad(e, t, n) {
  if (e.length !== t.length)
    return !1;
  for (let o = 0; o < e.length; o++) {
    const r = e[o], a = t[o];
    if (!pe(r, a, n))
      return !1;
  }
  return !0;
}
function Ye({
  panelConstraints: e,
  panelIndex: t,
  size: n
}) {
  const o = e[t];
  H(o != null, `Panel constraints not found for index ${t}`);
  let {
    collapsedSize: r = 0,
    collapsible: a,
    maxSize: i = 100,
    minSize: c = 0
  } = o;
  if (We(n, c) < 0)
    if (a) {
      const l = (r + c) / 2;
      We(n, l) < 0 ? n = r : n = c;
    } else
      n = c;
  return n = Math.min(i, n), n = parseFloat(n.toFixed(kn)), n;
}
function at({
  delta: e,
  initialLayout: t,
  panelConstraints: n,
  pivotIndices: o,
  prevLayout: r,
  trigger: a
}) {
  if (pe(e, 0))
    return t;
  const i = [...t], [c, l] = o;
  H(c != null, "Invalid first pivot index"), H(l != null, "Invalid second pivot index");
  let u = 0;
  if (a === "keyboard") {
    {
      const d = e < 0 ? l : c, p = n[d];
      H(p, `Panel constraints not found for index ${d}`);
      const {
        collapsedSize: g = 0,
        collapsible: h,
        minSize: v = 0
      } = p;
      if (h) {
        const S = t[d];
        if (H(S != null, `Previous layout not found for panel index ${d}`), pe(S, g)) {
          const w = v - S;
          We(w, Math.abs(e)) > 0 && (e = e < 0 ? 0 - w : w);
        }
      }
    }
    {
      const d = e < 0 ? c : l, p = n[d];
      H(p, `No panel constraints found for index ${d}`);
      const {
        collapsedSize: g = 0,
        collapsible: h,
        minSize: v = 0
      } = p;
      if (h) {
        const S = t[d];
        if (H(S != null, `Previous layout not found for panel index ${d}`), pe(S, v)) {
          const w = S - g;
          We(w, Math.abs(e)) > 0 && (e = e < 0 ? 0 - w : w);
        }
      }
    }
  }
  {
    const d = e < 0 ? 1 : -1;
    let p = e < 0 ? l : c, g = 0;
    for (; ; ) {
      const v = t[p];
      H(v != null, `Previous layout not found for panel index ${p}`);
      const w = Ye({
        panelConstraints: n,
        panelIndex: p,
        size: 100
      }) - v;
      if (g += w, p += d, p < 0 || p >= n.length)
        break;
    }
    const h = Math.min(Math.abs(e), Math.abs(g));
    e = e < 0 ? 0 - h : h;
  }
  {
    let p = e < 0 ? c : l;
    for (; p >= 0 && p < n.length; ) {
      const g = Math.abs(e) - Math.abs(u), h = t[p];
      H(h != null, `Previous layout not found for panel index ${p}`);
      const v = h - g, S = Ye({
        panelConstraints: n,
        panelIndex: p,
        size: v
      });
      if (!pe(h, S) && (u += h - S, i[p] = S, u.toPrecision(3).localeCompare(Math.abs(e).toPrecision(3), void 0, {
        numeric: !0
      }) >= 0))
        break;
      e < 0 ? p-- : p++;
    }
  }
  if (Ad(r, i))
    return r;
  {
    const d = e < 0 ? l : c, p = t[d];
    H(p != null, `Previous layout not found for panel index ${d}`);
    const g = p + u, h = Ye({
      panelConstraints: n,
      panelIndex: d,
      size: g
    });
    if (i[d] = h, !pe(h, g)) {
      let v = g - h, w = e < 0 ? l : c;
      for (; w >= 0 && w < n.length; ) {
        const y = i[w];
        H(y != null, `Previous layout not found for panel index ${w}`);
        const C = y + v, N = Ye({
          panelConstraints: n,
          panelIndex: w,
          size: C
        });
        if (pe(y, N) || (v -= N - y, i[w] = N), pe(v, 0))
          break;
        e > 0 ? w-- : w++;
      }
    }
  }
  const m = i.reduce((d, p) => p + d, 0);
  return pe(m, 100) ? i : r;
}
function Md({
  layout: e,
  panelsArray: t,
  pivotIndices: n
}) {
  let o = 0, r = 100, a = 0, i = 0;
  const c = n[0];
  H(c != null, "No pivot index found"), t.forEach((d, p) => {
    const {
      constraints: g
    } = d, {
      maxSize: h = 100,
      minSize: v = 0
    } = g;
    p === c ? (o = v, r = h) : (a += v, i += h);
  });
  const l = Math.min(r, 100 - a), u = Math.max(o, 100 - i), m = e[c];
  return {
    valueMax: l,
    valueMin: u,
    valueNow: m
  };
}
function ft(e, t = document) {
  return Array.from(t.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${e}"]`));
}
function Li(e, t, n = document) {
  const r = ft(e, n).findIndex((a) => a.getAttribute("data-panel-resize-handle-id") === t);
  return r ?? null;
}
function zi(e, t, n) {
  const o = Li(e, t, n);
  return o != null ? [o, o + 1] : [-1, -1];
}
function ki(e, t = document) {
  var n;
  if (t instanceof HTMLElement && (t == null || (n = t.dataset) === null || n === void 0 ? void 0 : n.panelGroupId) == e)
    return t;
  const o = t.querySelector(`[data-panel-group][data-panel-group-id="${e}"]`);
  return o || null;
}
function Gt(e, t = document) {
  const n = t.querySelector(`[data-panel-resize-handle-id="${e}"]`);
  return n || null;
}
function Id(e, t, n, o = document) {
  var r, a, i, c;
  const l = Gt(t, o), u = ft(e, o), m = l ? u.indexOf(l) : -1, d = (r = (a = n[m]) === null || a === void 0 ? void 0 : a.id) !== null && r !== void 0 ? r : null, p = (i = (c = n[m + 1]) === null || c === void 0 ? void 0 : c.id) !== null && i !== void 0 ? i : null;
  return [d, p];
}
function _d({
  committedValuesRef: e,
  eagerValuesRef: t,
  groupId: n,
  layout: o,
  panelDataArray: r,
  panelGroupElement: a,
  setLayout: i
}) {
  ue({
    didWarnAboutMissingResizeHandle: !1
  }), ke(() => {
    if (!a)
      return;
    const c = ft(n, a);
    for (let l = 0; l < r.length - 1; l++) {
      const {
        valueMax: u,
        valueMin: m,
        valueNow: d
      } = Md({
        layout: o,
        panelsArray: r,
        pivotIndices: [l, l + 1]
      }), p = c[l];
      if (p != null) {
        const g = r[l];
        H(g, `No panel data found for index "${l}"`), p.setAttribute("aria-controls", g.id), p.setAttribute("aria-valuemax", "" + Math.round(u)), p.setAttribute("aria-valuemin", "" + Math.round(m)), p.setAttribute("aria-valuenow", d != null ? "" + Math.round(d) : "");
      }
    }
    return () => {
      c.forEach((l, u) => {
        l.removeAttribute("aria-controls"), l.removeAttribute("aria-valuemax"), l.removeAttribute("aria-valuemin"), l.removeAttribute("aria-valuenow");
      });
    };
  }, [n, o, r, a]), ze(() => {
    if (!a)
      return;
    const c = t.current;
    H(c, "Eager values not found");
    const {
      panelDataArray: l
    } = c, u = ki(n, a);
    H(u != null, `No group found for id "${n}"`);
    const m = ft(n, a);
    H(m, `No resize handles found for group id "${n}"`);
    const d = m.map((p) => {
      const g = p.getAttribute("data-panel-resize-handle-id");
      H(g, "Resize handle element has no handle id attribute");
      const [h, v] = Id(n, g, l, a);
      if (h == null || v == null)
        return () => {
        };
      const S = (w) => {
        if (!w.defaultPrevented)
          switch (w.key) {
            case "Enter": {
              w.preventDefault();
              const y = l.findIndex((C) => C.id === h);
              if (y >= 0) {
                const C = l[y];
                H(C, `No panel data found for index ${y}`);
                const N = o[y], {
                  collapsedSize: z = 0,
                  collapsible: M,
                  minSize: P = 0
                } = C.constraints;
                if (N != null && M) {
                  const R = at({
                    delta: pe(N, z) ? P - z : z - N,
                    initialLayout: o,
                    panelConstraints: l.map((T) => T.constraints),
                    pivotIndices: zi(n, g, a),
                    prevLayout: o,
                    trigger: "keyboard"
                  });
                  o !== R && i(R);
                }
              }
              break;
            }
          }
      };
      return p.addEventListener("keydown", S), () => {
        p.removeEventListener("keydown", S);
      };
    });
    return () => {
      d.forEach((p) => p());
    };
  }, [a, e, t, n, o, r, i]);
}
function Yn(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Fi(e, t) {
  const n = e === "horizontal", {
    x: o,
    y: r
  } = Bt(t);
  return n ? o : r;
}
function Td(e, t, n, o, r) {
  const a = n === "horizontal", i = Gt(t, r);
  H(i, `No resize handle element found for id "${t}"`);
  const c = i.getAttribute("data-panel-group-id");
  H(c, "Resize handle element has no group id attribute");
  let {
    initialCursorPosition: l
  } = o;
  const u = Fi(n, e), m = ki(c, r);
  H(m, `No group element found for id "${c}"`);
  const d = m.getBoundingClientRect(), p = a ? d.width : d.height;
  return (u - l) / p * 100;
}
function Dd(e, t, n, o, r, a) {
  if (Ai(e)) {
    const i = n === "horizontal";
    let c = 0;
    e.shiftKey ? c = 100 : r != null ? c = r : c = 10;
    let l = 0;
    switch (e.key) {
      case "ArrowDown":
        l = i ? 0 : c;
        break;
      case "ArrowLeft":
        l = i ? -c : 0;
        break;
      case "ArrowRight":
        l = i ? c : 0;
        break;
      case "ArrowUp":
        l = i ? 0 : -c;
        break;
      case "End":
        l = 100;
        break;
      case "Home":
        l = -100;
        break;
    }
    return l;
  } else
    return o == null ? 0 : Td(e, t, n, o, a);
}
function Od({
  panelDataArray: e
}) {
  const t = Array(e.length), n = e.map((a) => a.constraints);
  let o = 0, r = 100;
  for (let a = 0; a < e.length; a++) {
    const i = n[a];
    H(i, `Panel constraints not found for index ${a}`);
    const {
      defaultSize: c
    } = i;
    c != null && (o++, t[a] = c, r -= c);
  }
  for (let a = 0; a < e.length; a++) {
    const i = n[a];
    H(i, `Panel constraints not found for index ${a}`);
    const {
      defaultSize: c
    } = i;
    if (c != null)
      continue;
    const l = e.length - o, u = r / l;
    o++, t[a] = u, r -= u;
  }
  return t;
}
function Ge(e, t, n) {
  t.forEach((o, r) => {
    const a = e[r];
    H(a, `Panel data not found for index ${r}`);
    const {
      callbacks: i,
      constraints: c,
      id: l
    } = a, {
      collapsedSize: u = 0,
      collapsible: m
    } = c, d = n[l];
    if (d == null || o !== d) {
      n[l] = o;
      const {
        onCollapse: p,
        onExpand: g,
        onResize: h
      } = i;
      h && h(o, d), m && (p || g) && (g && (d == null || Ne(d, u)) && !Ne(o, u) && g(), p && (d == null || !Ne(d, u)) && Ne(o, u) && p());
    }
  });
}
function xt(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] != t[n])
      return !1;
  return !0;
}
function $d({
  defaultSize: e,
  dragState: t,
  layout: n,
  panelData: o,
  panelIndex: r,
  precision: a = 3
}) {
  const i = n[r];
  let c;
  return i == null ? c = e != null ? e.toPrecision(a) : "1" : o.length === 1 ? c = "1" : c = i.toPrecision(a), {
    flexBasis: 0,
    flexGrow: c,
    flexShrink: 1,
    // Without this, Panel sizes may be unintentionally overridden by their content
    overflow: "hidden",
    // Disable pointer events inside of a panel during resize
    // This avoid edge cases like nested iframes
    pointerEvents: t !== null ? "none" : void 0
  };
}
function Ld(e, t = 10) {
  let n = null;
  return (...r) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      e(...r);
    }, t);
  };
}
function jn(e) {
  try {
    if (typeof localStorage < "u")
      e.getItem = (t) => localStorage.getItem(t), e.setItem = (t, n) => {
        localStorage.setItem(t, n);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (t) {
    console.error(t), e.getItem = () => null, e.setItem = () => {
    };
  }
}
function Vi(e) {
  return `react-resizable-panels:${e}`;
}
function Wi(e) {
  return e.map((t) => {
    const {
      constraints: n,
      id: o,
      idIsFromProps: r,
      order: a
    } = t;
    return r ? o : a ? `${a}:${JSON.stringify(n)}` : JSON.stringify(n);
  }).sort((t, n) => t.localeCompare(n)).join(",");
}
function Ui(e, t) {
  try {
    const n = Vi(e), o = t.getItem(n);
    if (o) {
      const r = JSON.parse(o);
      if (typeof r == "object" && r != null)
        return r;
    }
  } catch {
  }
  return null;
}
function zd(e, t, n) {
  var o, r;
  const a = (o = Ui(e, n)) !== null && o !== void 0 ? o : {}, i = Wi(t);
  return (r = a[i]) !== null && r !== void 0 ? r : null;
}
function kd(e, t, n, o, r) {
  var a;
  const i = Vi(e), c = Wi(t), l = (a = Ui(e, r)) !== null && a !== void 0 ? a : {};
  l[c] = {
    expandToSizes: Object.fromEntries(n.entries()),
    layout: o
  };
  try {
    r.setItem(i, JSON.stringify(l));
  } catch (u) {
    console.error(u);
  }
}
function Xn({
  layout: e,
  panelConstraints: t
}) {
  const n = [...e], o = n.reduce((a, i) => a + i, 0);
  if (n.length !== t.length)
    throw Error(`Invalid ${t.length} panel layout: ${n.map((a) => `${a}%`).join(", ")}`);
  if (!pe(o, 100) && n.length > 0)
    for (let a = 0; a < t.length; a++) {
      const i = n[a];
      H(i != null, `No layout data found for index ${a}`);
      const c = 100 / o * i;
      n[a] = c;
    }
  let r = 0;
  for (let a = 0; a < t.length; a++) {
    const i = n[a];
    H(i != null, `No layout data found for index ${a}`);
    const c = Ye({
      panelConstraints: t,
      panelIndex: a,
      size: i
    });
    i != c && (r += i - c, n[a] = c);
  }
  if (!pe(r, 0))
    for (let a = 0; a < t.length; a++) {
      const i = n[a];
      H(i != null, `No layout data found for index ${a}`);
      const c = i + r, l = Ye({
        panelConstraints: t,
        panelIndex: a,
        size: c
      });
      if (i !== l && (r -= l - i, n[a] = l, pe(r, 0)))
        break;
    }
  return n;
}
const Fd = 100, it = {
  getItem: (e) => (jn(it), it.getItem(e)),
  setItem: (e, t) => {
    jn(it), it.setItem(e, t);
  }
}, qn = {};
function Bi({
  autoSaveId: e = null,
  children: t,
  className: n = "",
  direction: o,
  forwardedRef: r,
  id: a = null,
  onLayout: i = null,
  keyboardResizeBy: c = null,
  storage: l = it,
  style: u,
  tagName: m = "div",
  ...d
}) {
  const p = $n(a), g = ue(null), [h, v] = je(null), [S, w] = je([]), y = Ed(), C = ue({}), N = ue(/* @__PURE__ */ new Map()), z = ue(0), M = ue({
    autoSaveId: e,
    direction: o,
    dragState: h,
    id: p,
    keyboardResizeBy: c,
    onLayout: i,
    storage: l
  }), P = ue({
    layout: S,
    panelDataArray: [],
    panelDataArrayChanged: !1
  });
  ue({
    didLogIdAndOrderWarning: !1,
    didLogPanelConstraintsWarning: !1,
    prevPanelIds: []
  }), Ri(r, () => ({
    getId: () => M.current.id,
    getLayout: () => {
      const {
        layout: x
      } = P.current;
      return x;
    },
    setLayout: (x) => {
      const {
        onLayout: I
      } = M.current, {
        layout: L,
        panelDataArray: _
      } = P.current, b = Xn({
        layout: x,
        panelConstraints: _.map((E) => E.constraints)
      });
      Yn(L, b) || (w(b), P.current.layout = b, I && I(b), Ge(_, b, C.current));
    }
  }), []), ke(() => {
    M.current.autoSaveId = e, M.current.direction = o, M.current.dragState = h, M.current.id = p, M.current.onLayout = i, M.current.storage = l;
  }), _d({
    committedValuesRef: M,
    eagerValuesRef: P,
    groupId: p,
    layout: S,
    panelDataArray: P.current.panelDataArray,
    setLayout: w,
    panelGroupElement: g.current
  }), ze(() => {
    const {
      panelDataArray: x
    } = P.current;
    if (e) {
      if (S.length === 0 || S.length !== x.length)
        return;
      let I = qn[e];
      I == null && (I = Ld(kd, Fd), qn[e] = I);
      const L = [...x], _ = new Map(N.current);
      I(e, L, _, S, l);
    }
  }, [e, S, l]), ze(() => {
  });
  const R = le((x) => {
    const {
      onLayout: I
    } = M.current, {
      layout: L,
      panelDataArray: _
    } = P.current;
    if (x.constraints.collapsible) {
      const b = _.map((W) => W.constraints), {
        collapsedSize: E = 0,
        panelSize: D,
        pivotIndices: O
      } = Oe(_, x, L);
      if (H(D != null, `Panel size not found for panel "${x.id}"`), !Ne(D, E)) {
        N.current.set(x.id, D);
        const U = Ke(_, x) === _.length - 1 ? D - E : E - D, B = at({
          delta: U,
          initialLayout: L,
          panelConstraints: b,
          pivotIndices: O,
          prevLayout: L,
          trigger: "imperative-api"
        });
        xt(L, B) || (w(B), P.current.layout = B, I && I(B), Ge(_, B, C.current));
      }
    }
  }, []), T = le((x, I) => {
    const {
      onLayout: L
    } = M.current, {
      layout: _,
      panelDataArray: b
    } = P.current;
    if (x.constraints.collapsible) {
      const E = b.map((ee) => ee.constraints), {
        collapsedSize: D = 0,
        panelSize: O = 0,
        minSize: W = 0,
        pivotIndices: U
      } = Oe(b, x, _), B = I ?? W;
      if (Ne(O, D)) {
        const ee = N.current.get(x.id), fe = ee != null && ee >= B ? ee : B, Se = Ke(b, x) === b.length - 1 ? O - fe : fe - O, re = at({
          delta: Se,
          initialLayout: _,
          panelConstraints: E,
          pivotIndices: U,
          prevLayout: _,
          trigger: "imperative-api"
        });
        xt(_, re) || (w(re), P.current.layout = re, L && L(re), Ge(b, re, C.current));
      }
    }
  }, []), V = le((x) => {
    const {
      layout: I,
      panelDataArray: L
    } = P.current, {
      panelSize: _
    } = Oe(L, x, I);
    return H(_ != null, `Panel size not found for panel "${x.id}"`), _;
  }, []), k = le((x, I) => {
    const {
      panelDataArray: L
    } = P.current, _ = Ke(L, x);
    return $d({
      defaultSize: I,
      dragState: h,
      layout: S,
      panelData: L,
      panelIndex: _
    });
  }, [h, S]), F = le((x) => {
    const {
      layout: I,
      panelDataArray: L
    } = P.current, {
      collapsedSize: _ = 0,
      collapsible: b,
      panelSize: E
    } = Oe(L, x, I);
    return H(E != null, `Panel size not found for panel "${x.id}"`), b === !0 && Ne(E, _);
  }, []), j = le((x) => {
    const {
      layout: I,
      panelDataArray: L
    } = P.current, {
      collapsedSize: _ = 0,
      collapsible: b,
      panelSize: E
    } = Oe(L, x, I);
    return H(E != null, `Panel size not found for panel "${x.id}"`), !b || We(E, _) > 0;
  }, []), Y = le((x) => {
    const {
      panelDataArray: I
    } = P.current;
    I.push(x), I.sort((L, _) => {
      const b = L.order, E = _.order;
      return b == null && E == null ? 0 : b == null ? -1 : E == null ? 1 : b - E;
    }), P.current.panelDataArrayChanged = !0, y();
  }, [y]);
  ke(() => {
    if (P.current.panelDataArrayChanged) {
      P.current.panelDataArrayChanged = !1;
      const {
        autoSaveId: x,
        onLayout: I,
        storage: L
      } = M.current, {
        layout: _,
        panelDataArray: b
      } = P.current;
      let E = null;
      if (x) {
        const O = zd(x, b, L);
        O && (N.current = new Map(Object.entries(O.expandToSizes)), E = O.layout);
      }
      E == null && (E = Od({
        panelDataArray: b
      }));
      const D = Xn({
        layout: E,
        panelConstraints: b.map((O) => O.constraints)
      });
      Yn(_, D) || (w(D), P.current.layout = D, I && I(D), Ge(b, D, C.current));
    }
  }), ke(() => {
    const x = P.current;
    return () => {
      x.layout = [];
    };
  }, []);
  const G = le((x) => {
    let I = !1;
    const L = g.current;
    return L && window.getComputedStyle(L, null).getPropertyValue("direction") === "rtl" && (I = !0), function(b) {
      b.preventDefault();
      const E = g.current;
      if (!E)
        return () => null;
      const {
        direction: D,
        dragState: O,
        id: W,
        keyboardResizeBy: U,
        onLayout: B
      } = M.current, {
        layout: ee,
        panelDataArray: fe
      } = P.current, {
        initialLayout: me
      } = O ?? {}, Se = zi(W, x, E);
      let re = Dd(b, x, D, O, U, E);
      const he = D === "horizontal";
      he && I && (re = -re);
      const Ki = fe.map((Yi) => Yi.constraints), tt = at({
        delta: re,
        initialLayout: me ?? ee,
        panelConstraints: Ki,
        pivotIndices: Se,
        prevLayout: ee,
        trigger: Ai(b) ? "keyboard" : "mouse-or-touch"
      }), Fn = !xt(ee, tt);
      (Mi(b) || Ii(b)) && z.current != re && (z.current = re, !Fn && re !== 0 ? he ? Xt(x, re < 0 ? Ti : Di) : Xt(x, re < 0 ? Oi : $i) : Xt(x, 0)), Fn && (w(tt), P.current.layout = tt, B && B(tt), Ge(fe, tt, C.current));
    };
  }, []), $ = le((x, I) => {
    const {
      onLayout: L
    } = M.current, {
      layout: _,
      panelDataArray: b
    } = P.current, E = b.map((ee) => ee.constraints), {
      panelSize: D,
      pivotIndices: O
    } = Oe(b, x, _);
    H(D != null, `Panel size not found for panel "${x.id}"`);
    const U = Ke(b, x) === b.length - 1 ? D - I : I - D, B = at({
      delta: U,
      initialLayout: _,
      panelConstraints: E,
      pivotIndices: O,
      prevLayout: _,
      trigger: "imperative-api"
    });
    xt(_, B) || (w(B), P.current.layout = B, L && L(B), Ge(b, B, C.current));
  }, []), J = le((x, I) => {
    const {
      layout: L,
      panelDataArray: _
    } = P.current, {
      collapsedSize: b = 0,
      collapsible: E
    } = I, {
      collapsedSize: D = 0,
      collapsible: O,
      maxSize: W = 100,
      minSize: U = 0
    } = x.constraints, {
      panelSize: B
    } = Oe(_, x, L);
    B != null && (E && O && Ne(B, b) ? Ne(b, D) || $(x, D) : B < U ? $(x, U) : B > W && $(x, W));
  }, [$]), K = le((x, I) => {
    const {
      direction: L
    } = M.current, {
      layout: _
    } = P.current;
    if (!g.current)
      return;
    const b = Gt(x, g.current);
    H(b, `Drag handle element not found for id "${x}"`);
    const E = Fi(L, I);
    v({
      dragHandleId: x,
      dragHandleRect: b.getBoundingClientRect(),
      initialCursorPosition: E,
      initialLayout: _
    });
  }, []), A = le(() => {
    v(null);
  }, []), Q = le((x) => {
    const {
      panelDataArray: I
    } = P.current, L = Ke(I, x);
    L >= 0 && (I.splice(L, 1), delete C.current[x.id], P.current.panelDataArrayChanged = !0, y());
  }, [y]), q = pd(() => ({
    collapsePanel: R,
    direction: o,
    dragState: h,
    expandPanel: T,
    getPanelSize: V,
    getPanelStyle: k,
    groupId: p,
    isPanelCollapsed: F,
    isPanelExpanded: j,
    reevaluatePanelConstraints: J,
    registerPanel: Y,
    registerResizeHandle: G,
    resizePanel: $,
    startDragging: K,
    stopDragging: A,
    unregisterPanel: Q,
    panelGroupElement: g.current
  }), [R, h, o, T, V, k, p, F, j, J, Y, G, $, K, A, Q]), te = {
    display: "flex",
    flexDirection: o === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return Ze(Ut.Provider, {
    value: q
  }, Ze(m, {
    ...d,
    children: t,
    className: n,
    id: a,
    ref: g,
    style: {
      ...te,
      ...u
    },
    // CSS selectors
    "data-panel-group": "",
    "data-panel-group-direction": o,
    "data-panel-group-id": p
  }));
}
const Hi = xi((e, t) => Ze(Bi, {
  ...e,
  forwardedRef: t
}));
Bi.displayName = "PanelGroup";
Hi.displayName = "forwardRef(PanelGroup)";
function Ke(e, t) {
  return e.findIndex((n) => n === t || n.id === t.id);
}
function Oe(e, t, n) {
  const o = Ke(e, t), a = o === e.length - 1 ? [o - 1, o] : [o, o + 1], i = n[o];
  return {
    ...t.constraints,
    panelSize: i,
    pivotIndices: a
  };
}
function Vd({
  disabled: e,
  handleId: t,
  resizeHandler: n,
  panelGroupElement: o
}) {
  ze(() => {
    if (e || n == null || o == null)
      return;
    const r = Gt(t, o);
    if (r == null)
      return;
    const a = (i) => {
      if (!i.defaultPrevented)
        switch (i.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
          case "End":
          case "Home": {
            i.preventDefault(), n(i);
            break;
          }
          case "F6": {
            i.preventDefault();
            const c = r.getAttribute("data-panel-group-id");
            H(c, `No group element found for id "${c}"`);
            const l = ft(c, o), u = Li(c, t, o);
            H(u !== null, `No resize element found for id "${t}"`);
            const m = i.shiftKey ? u > 0 ? u - 1 : l.length - 1 : u + 1 < l.length ? u + 1 : 0;
            l[m].focus();
            break;
          }
        }
    };
    return r.addEventListener("keydown", a), () => {
      r.removeEventListener("keydown", a);
    };
  }, [o, e, t, n]);
}
function Gi({
  children: e = null,
  className: t = "",
  disabled: n = !1,
  hitAreaMargins: o,
  id: r,
  onBlur: a,
  onDragging: i,
  onFocus: c,
  style: l = {},
  tabIndex: u = 0,
  tagName: m = "div",
  ...d
}) {
  var p, g;
  const h = ue(null), v = ue({
    onDragging: i
  });
  ze(() => {
    v.current.onDragging = i;
  });
  const S = Pi(Ut);
  if (S === null)
    throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
  const {
    direction: w,
    groupId: y,
    registerResizeHandle: C,
    startDragging: N,
    stopDragging: z,
    panelGroupElement: M
  } = S, P = $n(r), [R, T] = je("inactive"), [V, k] = je(!1), [F, j] = je(null), Y = ue({
    state: R
  });
  ke(() => {
    Y.current.state = R;
  }), ze(() => {
    if (n)
      j(null);
    else {
      const K = C(P);
      j(() => K);
    }
  }, [n, P, C]);
  const G = (p = o == null ? void 0 : o.coarse) !== null && p !== void 0 ? p : 15, $ = (g = o == null ? void 0 : o.fine) !== null && g !== void 0 ? g : 5;
  return ze(() => {
    if (n || F == null)
      return;
    const K = h.current;
    return H(K, "Element ref not attached"), Nd(P, K, w, {
      coarse: G,
      fine: $
    }, (Q, q, te) => {
      if (q)
        switch (Q) {
          case "down": {
            T("drag"), H(te, 'Expected event to be defined for "down" action'), N(P, te);
            const {
              onDragging: x
            } = v.current;
            x && x(!0);
            break;
          }
          case "move": {
            const {
              state: x
            } = Y.current;
            x !== "drag" && T("hover"), H(te, 'Expected event to be defined for "move" action'), F(te);
            break;
          }
          case "up": {
            T("hover"), z();
            const {
              onDragging: x
            } = v.current;
            x && x(!1);
            break;
          }
        }
      else
        T("inactive");
    });
  }, [G, w, n, $, C, P, F, N, z]), Vd({
    disabled: n,
    handleId: P,
    resizeHandler: F,
    panelGroupElement: M
  }), Ze(m, {
    ...d,
    children: e,
    className: t,
    id: r,
    onBlur: () => {
      k(!1), a == null || a();
    },
    onFocus: () => {
      k(!0), c == null || c();
    },
    ref: h,
    role: "separator",
    style: {
      ...{
        touchAction: "none",
        userSelect: "none"
      },
      ...l
    },
    tabIndex: u,
    // CSS selectors
    "data-panel-group-direction": w,
    "data-panel-group-id": y,
    "data-resize-handle": "",
    "data-resize-handle-active": R === "drag" ? "pointer" : V ? "keyboard" : void 0,
    "data-resize-handle-state": R,
    "data-panel-resize-handle-enabled": !n,
    "data-panel-resize-handle-id": P
  });
}
Gi.displayName = "PanelResizeHandle";
const cf = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  Hi,
  {
    className: Z(
      "flex h-full w-full data-[panel-group-direction=vertical]:flex-col",
      e
    ),
    ...t
  }
), lf = Ei, uf = ({
  withHandle: e,
  className: t,
  ...n
}) => /* @__PURE__ */ f(
  Gi,
  {
    className: Z(
      "relative flex w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0 [&[data-panel-group-direction=vertical]>div]:rotate-90",
      t
    ),
    ...n,
    children: e && /* @__PURE__ */ f("div", { className: "z-10 flex h-4 w-3 items-center justify-center rounded-sm border bg-border", children: /* @__PURE__ */ f(Zi, { className: "h-2.5 w-2.5" }) })
  }
);
export {
  is as A,
  qd as B,
  Zd as C,
  Yd as D,
  al as E,
  rl as F,
  Jd as G,
  tf as H,
  fu as I,
  mu as J,
  Fa as K,
  Va as L,
  li as P,
  cf as R,
  ef as S,
  af as T,
  jd as a,
  ss as b,
  cs as c,
  il as d,
  ul as e,
  dl as f,
  sl as g,
  uu as h,
  nf as i,
  du as j,
  pu as k,
  cd as l,
  zu as m,
  ld as n,
  ni as o,
  ud as p,
  lf as q,
  uf as r,
  Ee as s,
  Ll as t,
  Je as u,
  en as v,
  cl as w,
  ll as x,
  fl as y,
  Xd as z
};
